/* German texts, keyed by the English source text (see i18n.ts). */
export const DE: Record<string, string> = {
  'Picked {c}.':
    'Farbe {c} gewählt.',
  'Picked {c} (not in the palette – add it with “From drawing”).':
    'Farbe {c} gewählt (nicht in der Palette – mit „Aus Zeichnung“ hinzufügen).',
  'No painted area under the cursor.':
    'Unter dem Mauszeiger ist keine bemalte Fläche.',
  'My palette':
    'Meine Palette',
  'Could not read this file as SVG.':
    'Diese Datei lässt sich nicht als SVG lesen.',
  'From file':
    'Aus Datei',
  'The file’s colors were added as the palette “{name}”.':
    'Die Farben der Datei wurden als Palette „{name}“ hinzugefügt.',
  'Discard unsaved changes to the current drawing?\n(A copy is kept in History.)':
    'Ungespeicherte Änderungen an der aktuellen Zeichnung verwerfen?\n(Eine Kopie bleibt im Verlauf.)',
  'Before opening {name}':
    'Vor dem Öffnen von {name}',
  'Opened {name}':
    '{name} geöffnet',
  'Saved {name}':
    '{name} gespeichert',
  'File name:':
    'Dateiname:',
  'PNG width in pixels:':
    'PNG-Breite in Pixeln:',
  'Invalid width.':
    'Ungültige Breite.',
  'PNG export failed.':
    'PNG-Export fehlgeschlagen.',
  'Before starting a new drawing':
    'Vor dem Beginn einer neuen Zeichnung',
  'Applied the grout color and width to {n} {n|line|lines}.':
    'Fugenfarbe und -breite auf {n} {n|Linie|Linien} angewendet.',
  'Autosave failed – remember to save your file.':
    'Automatisches Speichern fehlgeschlagen – denken Sie daran, Ihre Datei zu speichern.',
  'Autosave':
    'Automatisch gespeichert',
  'Before restoring an older version':
    'Vor dem Wiederherstellen einer älteren Version',
  'Restored the version from {time}':
    'Version vom {time} wiederhergestellt',
  'Symmetry center set.':
    'Symmetriezentrum gesetzt.',
  'Snapping on':
    'Einrasten an',
  'Snapping off':
    'Einrasten aus',
  'The clipboard has no color codes.':
    'Die Zwischenablage enthält keine Farbcodes.',
  '{n} {n|area|areas}':
    '{n} {n|Fläche|Flächen}',
  'fill':
    'Füllung',
  'stroke':
    'Kontur',
  'No color – the bucket erases with it':
    'Keine Farbe – der Farbeimer radiert damit',
  'Recolored {n} {n|element|elements}.':
    '{n} {n|Element|Elemente} umgefärbt.',
  'Click on the canvas to place the symmetry center.':
    'Klicken Sie auf die Zeichenfläche, um das Symmetriezentrum zu setzen.',
  'Photo unlocked: drag it with the Select tool (where there are no shapes).':
    'Foto entsperrt: Ziehen Sie es mit dem Auswahlwerkzeug (dort, wo keine Formen sind).',
  'Remove the tracing photo?':
    'Das Foto zum Nachzeichnen entfernen?',
  'Invalid page size.':
    'Ungültige Seitengröße.',
  '1 drawing unit = 1 {unit}. Set the page size to the real size of your mosaic.':
    '1 Zeichnungseinheit = 1 {unit}. Stellen Sie die Seitengröße auf die echte Größe Ihres Mosaiks ein.',
  'Could not read that image.':
    'Dieses Bild lässt sich nicht lesen.',
  'Photo loaded and locked. Unlock it to move it with the Select tool.':
    'Foto geladen und gesperrt. Entsperren Sie es, um es mit dem Auswahlwerkzeug zu verschieben.',
  'Replace the photo to trace with the pasted image?':
    'Das Foto zum Nachzeichnen durch das eingefügte Bild ersetzen?',
  'The pasted image is now the photo to trace – “Make a mosaic from the photo” turns it into tiles.':
    'Das eingefügte Bild ist jetzt das Foto zum Nachzeichnen – „Mosaik aus dem Foto erstellen“ macht Fliesen daraus.',
  'Replace photo…':
    'Foto ersetzen…',
  'Load photo…':
    'Foto laden…',
  'Close shape':
    'Form schließen',
  'Done':
    'Fertig',
  'Start the cut inside a closed area.':
    'Beginnen Sie den Schnitt in einer geschlossenen Fläche.',
  'Click inside a closed area (or use “Fill whole page”).':
    'Klicken Sie in eine geschlossene Fläche (oder nutzen Sie „Ganze Seite füllen“).',
  'That would be about {n} tiles – make the tile size bigger.':
    'Das wären etwa {n} Fliesen – wählen Sie eine größere Fliesengröße.',
  'The tiles are bigger than this area.':
    'Die Fliesen sind größer als diese Fläche.',
  'This adds {n} lines, which may make editing slow. Continue?':
    'Das fügt {n} Linien hinzu, was das Bearbeiten verlangsamen kann. Fortfahren?',
  'Added the pattern “{type}” ({n} {n|line|lines}).':
    'Muster „{type}“ hinzugefügt ({n} {n|Linie|Linien}).',
  'The rows are wider than this area – use a smaller size.':
    'Die Reihen sind breiter als diese Fläche – wählen Sie eine kleinere Größe.',
  'This area is too narrow for a row of that width.':
    'Diese Fläche ist für eine Reihe dieser Breite zu schmal.',
  'Added {rows} {rows|row line|row lines} and {cuts} {cuts|cut|cuts} following the outline.':
    '{rows} {rows|Reihenlinie|Reihenlinien} und {cuts} {cuts|Schnitt|Schnitte} entlang der Kontur hinzugefügt.',
  'Painted areas are locked or hidden (see Layers).':
    'Bemalte Flächen sind gesperrt oder ausgeblendet (siehe Ebenen).',
  'No closed area here. The red circles show line ends that don’t touch anything.':
    'Hier ist keine geschlossene Fläche. Die roten Kreise zeigen Linienenden, die nichts berühren.',
  'No closed area here – make sure the lines meet.':
    'Hier ist keine geschlossene Fläche – prüfen Sie, ob sich die Linien treffen.',
  'Click to select (Shift adds) · drag to move – the nearest corner snaps · drag handles to edit; shared corners move together (Alt detaches) · yellow handles resize a polygon':
    'Klicken zum Auswählen (Umschalt fügt hinzu) · Ziehen zum Verschieben – die nächste Ecke rastet ein · Griffe ziehen zum Bearbeiten; gemeinsame Ecken bewegen sich zusammen (Alt trennt) · gelbe Griffe ändern die Größe eines Vielecks',
  'Click–click or drag · ends snap to points and onto other lines · Shift: 15° steps · Alt: no snap · Esc: stop':
    'Klick–Klick oder Ziehen · Enden rasten an Punkten und auf anderen Linien ein · Umschalt: 15°-Schritte · Alt: ohne Einrasten · Esc: beenden',
  'Click corner by corner · click the first corner, double-click or press Enter to close · Backspace removes the last corner · Esc cancels':
    'Ecke für Ecke klicken · zum Schließen auf die erste Ecke klicken, doppelklicken oder Enter drücken · Rücktaste entfernt die letzte Ecke · Esc bricht ab',
  'Drag from the center (or along an edge in “From edge” mode) · click = last size · Shift: 15° rotation · Ctrl: flip side · keys 3–9: sides':
    'Vom Mittelpunkt ziehen (oder entlang einer Kante im Modus „Von Kante“) · Klick = letzte Größe · Umschalt: 15°-Drehung · Strg: Seite wechseln · Tasten 3–9: Seitenzahl',
  'Drag across a tile to cut it straight through, edge to edge · Shift: 15° steps':
    'Über eine Fliese ziehen, um sie gerade von Kante zu Kante zu schneiden · Umschalt: 15°-Schritte',
  'Click inside a closed area to fill it with the chosen pattern':
    'In eine geschlossene Fläche klicken, um sie mit dem gewählten Muster zu füllen',
  'Click or drag across tiles to paint them · click again to recolor · ∅ swatch erases · Alt+click: pick a color':
    'Klicken oder über Fliesen ziehen, um sie zu bemalen · erneut klicken zum Umfärben · Farbfeld ∅ radiert · Alt+Klick: Farbe aufnehmen',
  'Drag to pan · mouse wheel zooms':
    'Ziehen zum Verschieben · Mausrad zoomt',
  'The lines layer is locked or hidden (see Layers).':
    'Die Linienebene ist gesperrt oder ausgeblendet (siehe Ebenen).',
  'About {n} tiles – too many, use a bigger tile size.':
    'Etwa {n} Fliesen – zu viele, wählen Sie eine größere Fliesengröße.',
  'About {n} tiles.':
    'Etwa {n} Fliesen.',
  'Load a photo first.':
    'Laden Sie zuerst ein Foto.',
  'That gives {n} tiles – use a bigger tile size.':
    'Das ergibt {n} Fliesen – wählen Sie eine größere Fliesengröße.',
  'Before making a mosaic from the photo':
    'Vor dem Erstellen eines Mosaiks aus dem Foto',
  'From photo':
    'Aus Foto',
  'New palette “{name}” with {n} {n|color|colors}.':
    'Neue Palette „{name}“ mit {n} {n|Farbe|Farben}.',
  'Made a mosaic of {n} tiles from the photo.':
    'Mosaik aus {n} Fliesen aus dem Foto erstellt.',
  'Working…':
    'Arbeite…',
  'Make mosaic':
    'Mosaik erstellen',
  'Versions are kept in this browser: every few minutes while you work, and before you open, start or restore another drawing. Restoring keeps your current drawing as a version too.':
    'Versionen werden in diesem Browser gespeichert: alle paar Minuten während der Arbeit und bevor Sie eine andere Zeichnung öffnen, beginnen oder wiederherstellen. Beim Wiederherstellen wird auch die aktuelle Zeichnung als Version gespeichert.',
  'No versions yet. A version is kept every few minutes while you work, and before you open or start another drawing.':
    'Noch keine Versionen. Eine Version wird alle paar Minuten während der Arbeit gespeichert und bevor Sie eine andere Zeichnung öffnen oder beginnen.',
  '{n} painted {n|area|areas}':
    '{n} {n|bemalte Fläche|bemalte Flächen}',
  'Saved by hand':
    'Von Hand gespeichert',
  'This browser can’t copy images – use PNG to save one instead.':
    'Dieser Browser kann keine Bilder kopieren – speichern Sie stattdessen ein PNG.',
  'Copied the drawing as an image – paste it into the raster app or any other program.':
    'Zeichnung als Bild kopiert – fügen Sie sie in die Raster-App oder ein anderes Programm ein.',
  'Could not copy the image (the browser refused).':
    'Das Bild konnte nicht kopiert werden (der Browser hat es abgelehnt).',
  '{n} {n|panel|panels} ({rows} × {cols}) · each printed at real size on {s} {paper} {s|sheet|sheets}.':
    '{n} {n|Feld|Felder} ({rows} × {cols}) · jedes in Originalgröße auf {s} {paper}-{s|Blatt|Blättern} gedruckt.',
  'laying plan: {n} {n|panel|panels} ({rows} rows × {cols} columns) of {w} × {h} {unit}':
    'Verlegeplan: {n} {n|Feld|Felder} ({rows} Reihen × {cols} Spalten) zu je {w} × {h} {unit}',
  'Panel {n} – row {row}, column {col}':
    'Feld {n} – Reihe {row}, Spalte {col}',
  'Panel {n}':
    'Feld {n}',
  'Panel':
    'Feld',
  'tiles per panel and color':
    'Fliesen je Feld und Farbe',
  'laying plan':
    'Verlegeplan',
  '{c} – click to remove from the mix':
    '{c} – klicken, um sie aus der Mischung zu entfernen',
  'Shift+click two or more swatches to put them in the mix.':
    'Umschalt+Klick auf zwei oder mehr Farbfelder legt sie in die Mischung.',
  'Each tile gets one of these {n} colors at random. Shift+click swatches to change the mix.':
    'Jede Fliese bekommt zufällig eine dieser {n} Farben. Umschalt+Klick auf Farbfelder ändert die Mischung.',
  'Put at least two colors in the mix first (Shift+click swatches).':
    'Legen Sie zuerst mindestens zwei Farben in die Mischung (Umschalt+Klick auf Farbfelder).',
  'Mixed the colors of {n} {n|area|areas}.':
    'Farben von {n} {n|Fläche|Flächen} gemischt.',
  'Select painted areas first.':
    'Wählen Sie zuerst bemalte Flächen aus.',
  'Cut {n} {n|shape|shapes}. Paste with Ctrl+V – also in another page or drawing.':
    '{n} {n|Form|Formen} ausgeschnitten. Mit Strg+V einfügen – auch auf einer anderen Seite oder in einer anderen Zeichnung.',
  'Copied {n} {n|shape|shapes}. Paste with Ctrl+V – also in another page or drawing.':
    '{n} {n|Form|Formen} kopiert. Mit Strg+V einfügen – auch auf einer anderen Seite oder in einer anderen Zeichnung.',
  'Pasted {n} {n|shape|shapes}.':
    '{n} {n|Form|Formen} eingefügt.',
  'Could not store the motifs.':
    'Die Motive konnten nicht gespeichert werden.',
  'No motifs yet. Select some shapes and save them.':
    'Noch keine Motive. Wählen Sie einige Formen aus und speichern Sie sie.',
  '{name} – click, then click on the drawing to place it':
    '{name} – klicken, dann in die Zeichnung klicken, um es zu platzieren',
  'Delete this motif':
    'Dieses Motiv löschen',
  'Delete the motif “{name}”?':
    'Das Motiv „{name}“ löschen?',
  'Select the shapes of the motif first (Select tool).':
    'Wählen Sie zuerst die Formen des Motivs aus (Auswahlwerkzeug).',
  'Name of the motif:':
    'Name des Motivs:',
  'Motif {n}':
    'Motiv {n}',
  'Saved the motif “{name}”.':
    'Motiv „{name}“ gespeichert.',
  'This motif could not be read.':
    'Dieses Motiv lässt sich nicht lesen.',
  'Placed “{name}”. Click again for another one, R turns it, Esc stops.':
    '„{name}“ platziert. Erneut klicken für ein weiteres, R dreht es, Esc beendet.',
  'Click to place the motif · R: turn it by 15° (Shift+R: 90°) · Esc: stop':
    'Klicken, um das Motiv zu platzieren · R: um 15° drehen (Umschalt+R: 90°) · Esc: beenden',
  'There are no motifs to export yet.':
    'Es gibt noch keine Motive zum Exportieren.',
  'Imported {n} {n|motif|motifs}.':
    '{n} {n|Motiv|Motive} importiert.',
  'No motifs found in that file.':
    'In dieser Datei wurden keine Motive gefunden.',
  'That file is not a motif library.':
    'Diese Datei ist keine Motivbibliothek.',
  'Page {n}':
    'Seite {n}',
  '{name} copy':
    '{name} – Kopie',
  'Page name:':
    'Seitenname:',
  'A project needs at least one page.':
    'Ein Projekt braucht mindestens eine Seite.',
  'Delete the page “{name}”? (A copy of the project is kept in History.)':
    'Die Seite „{name}“ löschen? (Eine Kopie des Projekts bleibt im Verlauf.)',
  'Before deleting the page {name}':
    'Vor dem Löschen der Seite {name}',
  'Rename…':
    'Umbenennen…',
  'Duplicate':
    'Duplizieren',
  'Move left':
    'Nach links',
  'Move right':
    'Nach rechts',
  'Delete…':
    'Löschen…',
  'Double-click to rename':
    'Doppelklick zum Umbenennen',
  'Switch to this page':
    'Zu dieser Seite wechseln',
  'Page options':
    'Seitenoptionen',
  'Load a photo first (Photo section).':
    'Laden Sie zuerst ein Foto (Bereich Foto zum Nachzeichnen).',
  'The palette is empty – add colors first.':
    'Die Palette ist leer – fügen Sie zuerst Farben hinzu.',
  'Colored {n} {n|area|areas} with the closest palette colors':
    '{n} {n|Fläche|Flächen} mit den nächstliegenden Palettenfarben bemalt',
  '{n} already painted (left as they were)':
    '{n} schon bemalt (unverändert gelassen)',
  '{n} outside the photo':
    '{n} außerhalb des Fotos',
  'colors':
    'Farben',
  'The browser blocked the print window – allow pop-ups for this page.':
    'Der Browser hat das Druckfenster blockiert – erlauben Sie Pop-ups für diese Seite.',
  'Nothing to import from the raster app.':
    'Aus der Raster-App gibt es nichts zu importieren.',
  'Opened {n} tiles from the raster app – your previous drawing is in History.':
    '{n} Fliesen aus der Raster-App geöffnet – Ihre vorige Zeichnung ist im Verlauf.',
  '<b>{n}</b> painted {n|area|areas} in <b>{c}</b> {c|color|colors}':
    '<b>{n}</b> {n|bemalte Fläche|bemalte Flächen} in <b>{c}</b> {c|Farbe|Farben}',
  '<b>{n}</b> not painted yet':
    '<b>{n}</b> noch nicht bemalt',
  'everything is painted':
    'alles ist bemalt',
  'page {w} × {h} {unit}':
    'Seite {w} × {h} {unit}',
  'Color':
    'Farbe',
  'Areas':
    'Flächen',
  'Total area':
    'Gesamtfläche',
  'Share':
    'Teilen',
  'Pieces of the size set above, plus waste':
    'Stücke der oben eingestellten Größe, plus Verschnitt',
  'Pieces to buy':
    'Zu kaufende Stücke',
  'Replace with':
    'Ersetzen durch',
  'Erase':
    'Löschen',
  'Nothing is painted yet. Use the paint bucket, or “Color tiles from photo”.':
    'Noch ist nichts bemalt. Nutzen Sie den Farbeimer oder „Fliesen aus Foto färben“.',
  'Recolored {n} {n|area|areas}.':
    '{n} {n|Fläche|Flächen} umgefärbt.',
  'Erased {n} {n|area|areas}.':
    '{n} {n|Fläche|Flächen} gelöscht.',
  'Colors that may look alike':
    'Farben, die ähnlich aussehen können',
  '{a} and {b} {how}':
    '{a} und {b} {how}',
  'The link would be {kb} KB – too long. Share the file instead, or leave out the photo.':
    'Der Link wäre {kb} KB groß – zu lang. Teilen Sie lieber die Datei oder lassen Sie das Foto weg.',
  'The link is {kb} KB – long links can get cut off in some messengers; sharing the file is safer. Anyone with it can view the mosaic and make their own copy.':
    'Der Link ist {kb} KB groß – lange Links werden in manchen Messengern abgeschnitten; die Datei zu teilen ist sicherer. Jeder mit dem Link kann das Mosaik ansehen und eine eigene Kopie anlegen.',
  'The link is {kb} KB. Anyone with it can view the mosaic and make their own copy.':
    'Der Link ist {kb} KB groß. Jeder mit dem Link kann das Mosaik ansehen und eine eigene Kopie anlegen.',
  'Sharing failed.':
    'Teilen fehlgeschlagen.',
  'Link copied.':
    'Link kopiert.',
  'This share link is damaged or incomplete.':
    'Dieser Link ist beschädigt oder unvollständig.',
  'Before opening a shared mosaic':
    'Vor dem Öffnen eines geteilten Mosaiks',
  'This is now your own copy – it is saved in this browser like any drawing.':
    'Das ist jetzt Ihre eigene Kopie – sie wird wie jede Zeichnung in diesem Browser gespeichert.',
  'Normal colors':
    'Normale Farben',
  'Black & white':
    'Schwarzweiß',
  'Red-blind (protanopia)':
    'Rotblind (Protanopie)',
  'Green-blind (deuteranopia)':
    'Grünblind (Deuteranopie)',
  'Blue-blind (tritanopia)':
    'Blaublind (Tritanopie)',
  'look almost the same':
    'sehen fast gleich aus',
  'in black & white':
    'in Schwarzweiß',
  'for red-blind viewers':
    'für Rotblinde',
  'for green-blind viewers':
    'für Grünblinde',
  'for blue-blind viewers':
    'für Blaublinde',
  'look alike {who}':
    'sehen {who} ähnlich aus',
  '{n} {n|tile blends|tiles blend} into a neighbour of another color.':
    '{n} {n|Fliese verschwimmt|Fliesen verschwimmen} mit einer Nachbarfliese anderer Farbe.',
  '{n} {n|tile blends|tiles blend} into a neighbour of another color (in this view).':
    '{n} {n|Fliese verschwimmt|Fliesen verschwimmen} mit einer Nachbarfliese anderer Farbe (in dieser Ansicht).',
  'No tile blends into its neighbours.':
    'Keine Fliese verschwimmt mit ihren Nachbarn.',
  'Sheet {sheet} – row {row}, column {col} of {cols} · blue strips are covered by the next sheet':
    'Blatt {sheet} – Reihe {row}, Spalte {col} von {cols} · blaue Streifen werden vom nächsten Blatt überdeckt',
  'One {paper} sheet ({orientation}), at {pct} % of the real size.':
    'Ein {paper}-Blatt ({orientation}), {pct} % der Originalgröße.',
  'One {paper} sheet ({orientation}) at real size.':
    'Ein {paper}-Blatt ({orientation}) in Originalgröße.',
  '{n} {paper} {n|sheet|sheets} ({orientation}, {rows} × {cols}, overlapping {overlap} mm) at real size.':
    '{n} {paper}-{n|Blatt|Blätter} ({orientation}, {rows} × {cols}, {overlap} mm Überlappung) in Originalgröße.',
  '{n} sheets ({rows} × {cols}), real size {w} × {h} cm':
    '{n} Blätter ({rows} × {cols}), Originalgröße {w} × {h} cm',
  'The picture has many colors: it is snapped to the current palette (use “Reduce to palette” to see the result first).':
    'Das Bild hat viele Farben: Es wird auf die aktuelle Palette umgerechnet (mit „Auf Palette reduzieren“ sehen Sie das Ergebnis vorher).',
  'The picture has many colors: it is snapped to 8 colors suggested from it.':
    'Das Bild hat viele Farben: Es wird auf 8 daraus vorgeschlagene Farben umgerechnet.',
  'Images':
    'Bilder',
  'PNG image':
    'PNG-Bild',
  'Discard unsaved changes to the current image?\n(Save it first if you want to keep it.)':
    'Ungespeicherte Änderungen am aktuellen Bild verwerfen?\n(Speichern Sie es zuerst, wenn Sie es behalten möchten.)',
  'Could not read {name} as an image.':
    '{name} lässt sich nicht als Bild lesen.',
  'Opened {name} ({w} × {h} px).':
    '{name} geöffnet ({w} × {h} px).',
  'Size of the new image in pixels (width × height):':
    'Größe des neuen Bildes in Pixeln (Breite × Höhe):',
  'Enter a size like 800 × 600 (at most {max} px a side).':
    'Geben Sie eine Größe wie 800 × 600 ein (höchstens {max} px pro Seite).',
  'Before starting a new image':
    'Vor dem Beginn eines neuen Bildes',
  'That version could not be read.':
    'Diese Version lässt sich nicht lesen.',
  'Export failed.':
    'Export fehlgeschlagen.',
  'Autosave failed – remember to save your image.':
    'Automatisches Speichern fehlgeschlagen – denken Sie daran, Ihr Bild zu speichern.',
  'The clipboard has no image or color codes.':
    'Die Zwischenablage enthält weder ein Bild noch Farbcodes.',
  'Versions are kept in this browser: every few minutes while you work, and before you open, start or restore another image. Restoring keeps your current image as a version too.':
    'Versionen werden in diesem Browser gespeichert: alle paar Minuten während der Arbeit und bevor Sie ein anderes Bild öffnen, beginnen oder wiederherstellen. Beim Wiederherstellen wird auch das aktuelle Bild als Version gespeichert.',
  'No versions yet. A version is kept every few minutes while you work, and before you open or start another image.':
    'Noch keine Versionen. Eine Version wird alle paar Minuten während der Arbeit gespeichert und bevor Sie ein anderes Bild öffnen oder beginnen.',
  'The palette is empty – add colors, or let the mosaic suggest some.':
    'Die Palette ist leer – fügen Sie Farben hinzu oder lassen Sie das Mosaik welche vorschlagen.',
  'There is nothing to make a mosaic from (the area is transparent).':
    'Es gibt nichts, woraus ein Mosaik werden kann (die Fläche ist transparent).',
  'From picture':
    'Aus Bild',
  'Made {n} {n|tile|tiles} in {c} {c|color|colors}.':
    '{n} {n|Fliese|Fliesen} in {c} {c|Farbe|Farben} erstellt.',
  'The palette is empty.':
    'Die Palette ist leer.',
  'Every pixel now has a palette color: {n} {n|pixel|pixels} in {c} {c|color|colors}.':
    'Jedes Pixel hat jetzt eine Palettenfarbe: {n} {n|Pixel|Pixel} in {c} {c|Farbe|Farben}.',
  'At most about {n} tiles in the selection – bigger ones where the picture is calm.':
    'Höchstens etwa {n} Fliesen in der Auswahl – größere, wo das Bild ruhig ist.',
  'At most about {n} tiles – bigger ones where the picture is calm.':
    'Höchstens etwa {n} Fliesen – größere, wo das Bild ruhig ist.',
  'About {n} tiles in the selection.':
    'Etwa {n} Fliesen in der Auswahl.',
  'Turn on “Fill” or “Outline” for polygons.':
    'Schalten Sie bei Vielecken „Füllung“ oder „Kontur“ ein.',
  'Picked “transparent”.':
    '„Transparent“ gewählt.',
  'Picked {c} (not in the palette – add it with “From image”).':
    'Farbe {c} gewählt (nicht in der Palette – mit „Aus Bild“ hinzufügen).',
  '{n} {n|pixel|pixels}':
    '{n} {n|Pixel|Pixel}',
  'paint color':
    'Malfarbe',
  'outline color':
    'Konturfarbe',
  'Transparent – paints and fills transparent pixels':
    'Transparent – malt und füllt mit transparenten Pixeln',
  'Recolored {n} {n|pixel|pixels}.':
    '{n} {n|Pixel|Pixel} umgefärbt.',
  'Nothing to paste – or the browser didn’t allow reading the clipboard (try Ctrl+V).':
    'Nichts zum Einfügen – oder der Browser erlaubt das Lesen der Zwischenablage nicht (versuchen Sie Strg+V).',
  'Enter a size from 1 to {max} px.':
    'Geben Sie eine Größe von 1 bis {max} px ein.',
  'This picture has {n} pieces – too many to number. Make a mosaic or reduce it to the palette first.':
    'Dieses Bild hat {n} Teile – zu viele zum Nummerieren. Machen Sie zuerst ein Mosaik daraus oder reduzieren Sie es auf die Palette.',
  '{n} {n|piece|pieces}':
    '{n} {n|Teil|Teile}',
  '{n} {n|piece|pieces} in {c} {c|color|colors} · {w} × {h} px':
    '{n} {n|Teil|Teile} in {c} {c|Farbe|Farben} · {w} × {h} px',
  'Nothing is painted yet.':
    'Noch ist nichts bemalt.',
  '{w} × {h} mm · {k} mm per pixel':
    '{w} × {h} mm · {k} mm pro Pixel',
  'Pieces':
    'Teile',
  'Pixels':
    'Pixel',
  'Area':
    'Fläche',
  'transparent':
    'transparent',
  '({w} × {h} px, not placed yet)':
    '({w} × {h} px, noch nicht platziert)',
  'Cut the selection – paste it here, into the vector app or any other program.':
    'Auswahl ausgeschnitten – fügen Sie sie hier, in der Vektor-App oder in einem anderen Programm ein.',
  'Cut the image – paste it here, into the vector app or any other program.':
    'Bild ausgeschnitten – fügen Sie es hier, in der Vektor-App oder in einem anderen Programm ein.',
  'Copied the selection – paste it here, into the vector app or any other program.':
    'Auswahl kopiert – fügen Sie sie hier, in der Vektor-App oder in einem anderen Programm ein.',
  'Copied the image – paste it here, into the vector app or any other program.':
    'Bild kopiert – fügen Sie es hier, in der Vektor-App oder in einem anderen Programm ein.',
  'Cut the selection (this browser keeps it for pasting here only).':
    'Auswahl ausgeschnitten (dieser Browser behält sie nur zum Einfügen hier).',
  'Cut the image (this browser keeps it for pasting here only).':
    'Bild ausgeschnitten (dieser Browser behält es nur zum Einfügen hier).',
  'Copied the selection (this browser keeps it for pasting here only).':
    'Auswahl kopiert (dieser Browser behält sie nur zum Einfügen hier).',
  'Copied the image (this browser keeps it for pasting here only).':
    'Bild kopiert (dieser Browser behält es nur zum Einfügen hier).',
  'Select the part to keep first.':
    'Wählen Sie zuerst den Teil aus, der bleiben soll.',
  'Could not read the pasted image.':
    'Das eingefügte Bild lässt sich nicht lesen.',
  'The pasted image ({w} × {h}) is bigger than this one ({W} × {H}). Enlarge the canvas to fit it?':
    'Das eingefügte Bild ({w} × {h}) ist größer als dieses ({W} × {H}). Die Zeichenfläche vergrößern, damit es passt?',
  'Pasted {w} × {h} px – drag it into place, then press Enter (or click outside it).':
    '{w} × {h} px eingefügt – an die richtige Stelle ziehen, dann Enter drücken (oder daneben klicken).',
  'The link would be {kb} KB – too long. Share the file instead (or make the image smaller).':
    'Der Link wäre {kb} KB groß – zu lang. Teilen Sie lieber die Datei (oder verkleinern Sie das Bild).',
  'The link is {kb} KB – long links can get cut off in some messengers; sharing the file is safer. Anyone with it can view the image and make their own copy.':
    'Der Link ist {kb} KB groß – lange Links werden in manchen Messengern abgeschnitten; die Datei zu teilen ist sicherer. Jeder mit dem Link kann das Bild ansehen und eine eigene Kopie anlegen.',
  'The link is {kb} KB. Anyone with it can view the image and make their own copy.':
    'Der Link ist {kb} KB groß. Jeder mit dem Link kann das Bild ansehen und eine eigene Kopie anlegen.',
  'Before opening a shared image':
    'Vor dem Öffnen eines geteilten Bildes',
  'This is now your own copy – it is saved in this browser like any image.':
    'Das ist jetzt Ihre eigene Kopie – sie wird wie jedes Bild in diesem Browser gespeichert.',
  'Drag to select · drag inside the selection to move it (Alt: a copy) · Enter places it · Ctrl+C / X / V copy, cut, paste':
    'Ziehen zum Auswählen · in der Auswahl ziehen zum Verschieben (Alt: eine Kopie) · Enter platziert sie · Strg+C / X / V kopieren, ausschneiden, einfügen',
  'Drag to paint · Shift: straight line · [ ] size · Shift+B: tip · Alt+click: pick a color':
    'Ziehen zum Malen · Umschalt: gerade Linie · [ ] Größe · Umschalt+B: Spitze · Alt+Klick: Farbe aufnehmen',
  'Hard pixels in exact colors · Shift: straight line · [ ] size · Alt+click: pick a color':
    'Harte Pixel in exakten Farben · Umschalt: gerade Linie · [ ] Größe · Alt+Klick: Farbe aufnehmen',
  'Drag to erase to transparent · Shift: straight line · [ ] size':
    'Ziehen zum Radieren (transparent) · Umschalt: gerade Linie · [ ] Größe',
  'Drag a line · Shift: 15° steps':
    'Eine Linie ziehen · Umschalt: 15°-Schritte',
  'Drag from the center · Shift: 15° rotation · keys 3–9: sides':
    'Vom Mittelpunkt ziehen · Umschalt: 15°-Drehung · Tasten 3–9: Seitenzahl',
  'Click to fill the area of similar color · Alt+click: pick a color':
    'Klicken, um die Fläche ähnlicher Farbe zu füllen · Alt+Klick: Farbe aufnehmen',
  'Click to take a color from the image':
    'Klicken, um eine Farbe aus dem Bild aufzunehmen',
  'No grout – every piece is a tile':
    'Keine Fugen – jedes Teil ist eine Fliese',
  '{n} {n|tile|tiles} at {w} × {h} mm – too many: make a mosaic or reduce the picture to the palette first.':
    '{n} {n|Fliese|Fliesen} auf {w} × {h} mm – zu viele: Machen Sie zuerst ein Mosaik oder reduzieren Sie das Bild auf die Palette.',
  '{n} {n|tile|tiles} at {w} × {h} mm.':
    '{n} {n|Fliese|Fliesen} auf {w} × {h} mm.',
  'Could not hand the tiles over (browser storage unavailable).':
    'Die Fliesen konnten nicht übergeben werden (Browserspeicher nicht verfügbar).',
  '3D print':
    '3D-Druck',
  'Close':
    'Schließen',
  'A model where every color stands at its own height. Print it with one nozzle and change the filament at the layers listed below – each tile’s top then shows its color. The 3MF file already contains the filament changes for PrusaSlicer; for other slicers, the plan lists them.':
    'Ein Modell, in dem jede Farbe ihre eigene Höhe hat. Drucken Sie es mit einer Düse und wechseln Sie das Filament in den unten genannten Schichten – die Oberseite jeder Fliese zeigt dann ihre Farbe. Die 3MF-Datei enthält die Filamentwechsel bereits für PrusaSlicer; für andere Slicer stehen sie im Plan.',
  'Size':
    'Größe',
  'Size of the model’s smallest step – about your nozzle width':
    'Größe des kleinsten Schritts des Modells – etwa Ihre Düsenbreite',
  'Detail':
    'Detail',
  'Layer height':
    'Schichthöhe',
  'How many layers each color gets – more layers cover the color below better':
    'Wie viele Schichten jede Farbe bekommt – mehr Schichten decken die Farbe darunter besser ab',
  'Layers per color':
    'Schichten pro Farbe',
  'A plate under everything, printed in the first color. 0: unpainted parts are left open':
    'Eine Platte unter allem, in der ersten Farbe gedruckt. 0: Unbemaltes bleibt offen',
  'Base layers':
    'Basisschichten',
  'Top view of the model':
    'Draufsicht auf das Modell',
  'Print order (bottom first):':
    'Druckreihenfolge (von unten):',
  'Lighter colors lower: a darker layer covers a lighter one well. Lines (grout) stay at the bottom':
    'Hellere Farben nach unten: Eine dunklere Schicht deckt eine hellere gut ab. Linien (Fugen) bleiben unten',
  'Light → dark':
    'Hell → dunkel',
  'Dark → light':
    'Dunkel → hell',
  'Which filament to load at which layer, as a text file':
    'Welches Filament in welcher Schicht einzulegen ist, als Textdatei',
  'Plan':
    'Plan',
  'Just the shape – add the filament changes from the plan in your slicer':
    'Nur die Form – fügen Sie die Filamentwechsel laut Plan im Slicer hinzu',
  'The model, with the filament changes for PrusaSlicer':
    'Das Modell mit den Filamentwechseln für PrusaSlicer',
  'Download 3MF':
    '3MF herunterladen',
  '{n} colors make a tall print with many filament changes – reduce the colors first (Raster: “Reduce to palette”).':
    '{n} Farben ergeben einen hohen Druck mit vielen Filamentwechseln – reduzieren Sie zuerst die Farben (Raster: „Auf Palette reduzieren“).',
  'Detail lowered to {d} mm for this size.':
    'Detail für diese Größe auf {d} mm verringert.',
  'lines':
    'Linien',
  'Print earlier (lower)':
    'Früher drucken (tiefer)',
  'Print later (higher)':
    'Später drucken (höher)',
  '{share} % · layers {from}–{to}':
    '{share} % · Schichten {from}–{to}',
  '{share} % · layers {from}–{to} · change at Z {z}':
    '{share} % · Schichten {from}–{to} · Wechsel bei Z {z}',
  '{n} {n|color|colors} · height {h} mm ({layers} {layers|layer|layers}) · {c} filament {c|change|changes}':
    '{n} {n|Farbe|Farben} · Höhe {h} mm ({layers} {layers|Schicht|Schichten}) · {c} {c|Filamentwechsel|Filamentwechsel}',
  'unpainted parts stay at the base ({h} mm)':
    'Unbemaltes bleibt auf Höhe der Basis ({h} mm)',
  'unpainted parts are left open':
    'Unbemaltes bleibt offen',
  'Mosaic Paint – 3D print plan for {name}.3mf / {name}.stl':
    'Mosaic Paint – 3D-Druckplan für {name}.3mf / {name}.stl',
  'Size {w} × {h} mm · layer height {lh} mm · {lpc} layers per color · base {base} layers':
    'Größe {w} × {h} mm · Schichthöhe {lh} mm · {lpc} Schichten pro Farbe · Basis {base} Schichten',
  'Total height {total} mm ({layers} layers). Set the slicer’s first layer height to {lh} mm too.':
    'Gesamthöhe {total} mm ({layers} Schichten). Stellen Sie auch die erste Schichthöhe im Slicer auf {lh} mm.',
  'Start with {color} – layers {from}–{to} (base plate included)':
    'Beginnen Sie mit {color} – Schichten {from}–{to} (Basisplatte inklusive)',
  'Start with {color} – layers {from}–{to}':
    'Beginnen Sie mit {color} – Schichten {from}–{to}',
  'Layer {layer} (Z {z} mm): change to {color} – layers {from}–{to}':
    'Schicht {layer} (Z {z} mm): Wechsel zu {color} – Schichten {from}–{to}',
  'PrusaSlicer: the 3MF file already contains these changes – open it and check the layer slider.':
    'PrusaSlicer: Die 3MF-Datei enthält diese Wechsel bereits – öffnen Sie sie und prüfen Sie den Schichtregler.',
  'Other slicers (they read only the shape from the 3MF or STL) – add the changes by hand:':
    'Andere Slicer (sie lesen aus 3MF oder STL nur die Form) – fügen Sie die Wechsel von Hand hinzu:',
  '- PrusaSlicer, Bambu Studio, OrcaSlicer: in the preview, move the layer slider to each Z above and click “+” (Add color change, M600).':
    '- PrusaSlicer, Bambu Studio, OrcaSlicer: In der Vorschau den Schichtregler auf jede Z-Höhe oben stellen und auf „+“ klicken (Farbwechsel hinzufügen, M600).',
  '- Cura: Extensions › Post Processing › Modify G-Code › “Filament Change” at each layer number above.':
    '- Cura: Erweiterungen › Nachbearbeitung › G-Code ändern › „Filament Change“ bei jeder Schichtnummer oben.',
  '- Multi-material printers (AMS, MMU): the same changes work; or assign the filaments to the color changes in the slicer.':
    '- Mehrmaterial-Drucker (AMS, MMU): Dieselben Wechsel funktionieren; oder ordnen Sie die Filamente im Slicer den Farbwechseln zu.',
  'Could not read the picture.':
    'Das Bild lässt sich nicht lesen.',
  'Saved {name}.3mf ({n} triangles; PrusaSlicer reads its {c} filament {c|change|changes}, other slicers need the plan).':
    '{name}.3mf gespeichert ({n} Dreiecke; PrusaSlicer liest {c} {c|Filamentwechsel|Filamentwechsel}, andere Slicer brauchen den Plan).',
  'Saved {name}.stl ({n} triangles). Add the filament changes from the plan in your slicer.':
    '{name}.stl gespeichert ({n} Dreiecke). Fügen Sie die Filamentwechsel laut Plan im Slicer hinzu.',
  'Reading the picture…':
    'Bild wird gelesen…',
  'History':
    'Verlauf',
  'Save a version now':
    'Jetzt eine Version speichern',
  'Version history needs browser storage (IndexedDB), which is not available here.':
    'Der Versionsverlauf braucht Browserspeicher (IndexedDB), der hier nicht verfügbar ist.',
  'Restore':
    'Wiederherstellen',
  'Version saved.':
    'Version gespeichert.',
  'Could not save a version (browser storage unavailable).':
    'Die Version konnte nicht gespeichert werden (Browserspeicher nicht verfügbar).',
  'used by {what}':
    'verwendet für {what}',
  'Click: {fill} · Right-click: {stroke} · Double-click: edit':
    'Klick: {fill} · Rechtsklick: {stroke} · Doppelklick: bearbeiten',
  'Remove from palette':
    'Aus der Palette entfernen',
  'Edit color (hex or any CSS color).\nThe drawing is recolored too.':
    'Farbe bearbeiten (Hex oder eine beliebige CSS-Farbe).\nDie Zeichnung wird ebenfalls umgefärbt.',
  'Not a valid color: {v}':
    'Keine gültige Farbe: {v}',
  'Paste a color code (or several) into the box, then press Enter.':
    'Fügen Sie einen Farbcode (oder mehrere) in das Feld ein und drücken Sie Enter.',
  'No color found in: {text}':
    'Keine Farbe gefunden in: {text}',
  'Added {n} {n|color|colors}.':
    '{n} {n|Farbe|Farben} hinzugefügt.',
  'Already in the palette.':
    'Schon in der Palette.',
  'Added {n} {n|color|colors} from the clipboard.':
    '{n} {n|Farbe|Farben} aus der Zwischenablage hinzugefügt.',
  'Those colors are already in the palette.':
    'Diese Farben sind schon in der Palette.',
  'Name of the new palette:':
    'Name der neuen Palette:',
  'Palette':
    'Palette',
  'Created “{name}”. Paste colors to fill it.':
    '„{name}“ erstellt. Fügen Sie Farben ein, um sie zu füllen.',
  'Rename palette:':
    'Palette umbenennen:',
  'Delete the palette “{name}”? (The drawing is not changed.)':
    'Die Palette „{name}“ löschen? (Die Zeichnung bleibt unverändert.)',
  'Added {n} {n|color|colors} from the drawing.':
    '{n} {n|Farbe|Farben} aus der Zeichnung hinzugefügt.',
  'No new colors in the drawing.':
    'Keine neuen Farben in der Zeichnung.',
  'Remove all colors from this palette? (The drawing is not changed.)':
    'Alle Farben aus dieser Palette entfernen? (Die Zeichnung bleibt unverändert.)',
  'Imported {n} {n|color|colors}.':
    '{n} {n|Farbe|Farben} importiert.',
  'No new colors found in {name}':
    'Keine neuen Farben in {name} gefunden',
  'Installed – Mosaic Paint now works offline too.':
    'Installiert – Mosaic Paint funktioniert jetzt auch offline.',
  'Simple':
    'Einfach',
  'Expert':
    'Experte',
  'New':
    'Neu',
  'Open…':
    'Öffnen…',
  'Save':
    'Speichern',
  'Save as…':
    'Speichern unter…',
  'Copy image':
    'Bild kopieren',
  'Print…':
    'Drucken…',
  'Plan…':
    'Plan…',
  'Report':
    'Übersicht',
  'Contrast':
    'Kontrast',
  'Share of area':
    'Flächenanteil',
  'Install app':
    'App installieren',
  'You are looking at a shared mosaic.':
    'Sie sehen ein geteiltes Mosaik.',
  'Make my own copy':
    'Eigene Kopie anlegen',
  'Back to my drawing':
    'Zurück zu meiner Zeichnung',
  'Remove last corner':
    'Letzte Ecke entfernen',
  'Cancel':
    'Abbrechen',
  'Colors':
    'Farben',
  'Fill':
    'Füllung',
  'Stroke':
    'Kontur',
  'Width':
    'Breite',
  'Add color':
    'Farbe hinzufügen',
  'Import…':
    'Importieren…',
  'From drawing':
    'Aus Zeichnung',
  'Export':
    'Exportieren',
  'Clear':
    'Leeren',
  'Click a swatch = fill · right-click = stroke · double-click = edit (also recolors the drawing) · Shift+click = add to the color mix. Ctrl+V on the canvas adds copied colors.':
    'Klick auf ein Farbfeld = Füllung · Rechtsklick = Kontur · Doppelklick = bearbeiten (färbt auch die Zeichnung um) · Umschalt+Klick = zur Farbmischung hinzufügen. Strg+V auf der Zeichenfläche fügt kopierte Farben hinzu.',
  'Line':
    'Linie',
  'Chain lines (next line starts at the last end)':
    'Linien verketten (die nächste Linie beginnt am letzten Ende)',
  'Free polygon':
    'Freies Vieleck',
  'Click each corner. Click the first corner again, double-click or press Enter to close it.':
    'Klicken Sie jede Ecke an. Zum Schließen die erste Ecke erneut anklicken, doppelklicken oder Enter drücken.',
  'Fill new shapes with the fill color':
    'Neue Formen mit der Füllfarbe füllen',
  'Regular polygon':
    'Regelmäßiges Vieleck',
  'Sides':
    'Seiten',
  'From center':
    'Vom Mittelpunkt',
  'From edge':
    'Von Kante',
  'Knife':
    'Messer',
  'Press inside a tile and drag in the direction of the cut. The tile is cut straight across, from edge to edge.':
    'In einer Fliese drücken und in Schnittrichtung ziehen. Die Fliese wird gerade von Kante zu Kante durchgeschnitten.',
  'Pattern':
    'Muster',
  'Angle':
    'Winkel',
  'Rows':
    'Reihen',
  'Fill whole page':
    'Ganze Seite füllen',
  'Click inside a closed area to fill it with tiles. Painted areas keep their color in every new tile. “Rows following the outline” lays rows along the area’s edge and around shapes inside it (Rows 0 = fill it).':
    'In eine geschlossene Fläche klicken, um sie mit Fliesen zu füllen. Bemalte Flächen behalten ihre Farbe in jeder neuen Fliese. „Reihen entlang der Kontur“ legt Reihen entlang des Flächenrands und um Formen darin (Reihen 0 = ganz füllen).',
  'Paint bucket':
    'Farbeimer',
  'Click inside any closed area, or drag across many tiles. Click a painted area again to recolor it. The ∅ swatch erases. Alt+click picks a color.':
    'In eine beliebige geschlossene Fläche klicken oder über viele Fliesen ziehen. Erneuter Klick auf eine bemalte Fläche färbt sie um. Das Farbfeld ∅ radiert. Alt+Klick nimmt eine Farbe auf.',
  'Mix colors (a random one per tile)':
    'Farben mischen (eine zufällige pro Fliese)',
  'Avoid the same color next to itself':
    'Gleiche Farbe nicht nebeneinander',
  'Close gaps up to':
    'Lücken schließen bis',
  'Photo to trace':
    'Foto zum Nachzeichnen',
  'Opacity':
    'Deckkraft',
  'Show':
    'Anzeigen',
  'Locked':
    'Gesperrt',
  'Fit to page':
    'An Seite anpassen',
  'Remove':
    'Entfernen',
  'Keep the photo in saved files':
    'Foto in gespeicherten Dateien behalten',
  'Make a mosaic from the photo…':
    'Mosaik aus dem Foto erstellen…',
  'Color my tiles from the photo':
    'Meine Fliesen nach dem Foto färben',
  'Only tiles that aren’t painted yet':
    'Nur noch nicht bemalte Fliesen',
  'Each tile gets the palette color closest to the photo underneath it. Draw the tile lines first.':
    'Jede Fliese bekommt die Palettenfarbe, die dem Foto darunter am nächsten kommt. Zeichnen Sie zuerst die Fliesenlinien.',
  'Grout preview':
    'Fugenvorschau',
  'Preview':
    'Vorschau',
  'Apply to all lines':
    'Auf alle Linien anwenden',
  'Motifs':
    'Motive',
  'Save selection…':
    'Auswahl speichern…',
  'Click a motif, then click on the drawing to place it (R turns it, Esc stops). Ctrl+C / Ctrl+X / Ctrl+V copy shapes between pages, drawings and browser tabs.':
    'Klicken Sie auf ein Motiv und dann in die Zeichnung, um es zu platzieren (R dreht es, Esc beendet). Strg+C / Strg+X / Strg+V kopieren Formen zwischen Seiten, Zeichnungen und Browser-Tabs.',
  'Symmetry':
    'Symmetrie',
  'Off':
    'Aus',
  'Mirror left ↔ right':
    'Spiegeln links ↔ rechts',
  'Mirror top ↕ bottom':
    'Spiegeln oben ↕ unten',
  'Mirror both ways':
    'In beide Richtungen spiegeln',
  'Rotate around center':
    'Um den Mittelpunkt drehen',
  'Copies':
    'Kopien',
  'also mirrored':
    'auch gespiegelt',
  'Pick center':
    'Mittelpunkt wählen',
  'Page center':
    'Seitenmitte',
  'Lines, polygons, knife cuts and painting are repeated around the guides.':
    'Linien, Vielecke, Messerschnitte und Bemalen werden um die Hilfslinien wiederholt.',
  'Layers':
    'Ebenen',
  'Lines & shapes':
    'Linien & Formen',
  'Painted areas':
    'Bemalte Flächen',
  'Photo':
    'Foto',
  'Lock the lines while painting so they can’t be moved by accident.':
    'Sperren Sie die Linien beim Bemalen, damit sie nicht versehentlich verschoben werden.',
  'Snapping':
    'Einrasten',
  'Snap to points & lines':
    'An Punkten & Linien einrasten',
  'Shared corners move together':
    'Gemeinsame Ecken bewegen sich zusammen',
  'Page edge counts as a line':
    'Seitenrand zählt als Linie',
  'Grid, size':
    'Raster, Größe',
  'Snaps to ends & corners ▢, crossings ✕, midpoints △, anywhere along a line ◇, centers ○. Hold Alt to place freely.':
    'Rastet an Enden & Ecken ▢, Kreuzungen ✕, Mittelpunkten △, überall auf einer Linie ◇ und Zentren ○ ein. Mit gedrückter Alt-Taste frei platzieren.',
  'Selection':
    'Auswahl',
  'Radius':
    'Radius',
  'Rotation°':
    'Drehung°',
  'Line width':
    'Linienbreite',
  'Delete':
    'Löschen',
  'To front':
    'Nach vorn',
  'To back':
    'Nach hinten',
  'Mix colors':
    'Farben mischen',
  'Page':
    'Seite',
  'Apply':
    'Anwenden',
  'Background':
    'Hintergrund',
  'Show rulers':
    'Lineale anzeigen',
  'Keyboard & mouse':
    'Tastatur & Maus',
  'Select, Line, Free polygon, Polygon, Ellipse, Curve, Pattern, Bucket, Pan':
    'Auswahl, Linie, Freies Vieleck, Vieleck, Ellipse, Kurve, Muster, Farbeimer, Verschieben',
  'Polygon sides':
    'Seitenzahl des Vielecks',
  'Toggle snapping':
    'Einrasten ein/aus',
  'Alt':
    'Alt',
  'Draw / drag without snapping; detach a shared corner; Alt+click with the bucket picks a color':
    'Ohne Einrasten zeichnen / ziehen; gemeinsame Ecke trennen; Alt+Klick mit dem Farbeimer nimmt eine Farbe auf',
  'Shift':
    'Umschalt',
  '15° steps; add to selection':
    '15°-Schritte; zur Auswahl hinzufügen',
  'Ctrl (polygon tool)':
    'Strg (Vieleck-Werkzeug)',
  'Flip side when drawing from an edge':
    'Beim Zeichnen von einer Kante die Seite wechseln',
  'Ctrl + drag handle':
    'Strg + Griff ziehen',
  'Freely move a polygon corner (it stops being regular)':
    'Eine Vieleckecke frei verschieben (es ist dann nicht mehr regelmäßig)',
  'Enter / Esc':
    'Enter / Esc',
  'Finish / cancel the current shape':
    'Aktuelle Form beenden / abbrechen',
  'Del':
    'Entf',
  'Delete selection (or the last corner of a free polygon)':
    'Auswahl löschen (oder die letzte Ecke eines freien Vielecks)',
  'Arrows':
    'Pfeiltasten',
  'Nudge (Shift = ×10)':
    'Verschieben (Umschalt = ×10)',
  'Undo / redo':
    'Rückgängig / wiederholen',
  'Copy, cut, paste shapes (also between pages and drawings). Ctrl+C with nothing selected copies the drawing as an image; pasting an image makes it the photo to trace':
    'Formen kopieren, ausschneiden, einfügen (auch zwischen Seiten und Zeichnungen). Strg+C ohne Auswahl kopiert die Zeichnung als Bild; ein eingefügtes Bild wird zum Foto zum Nachzeichnen',
  'Duplicate, select all':
    'Duplizieren, alles auswählen',
  'Wheel, Space+drag':
    'Mausrad, Leertaste+Ziehen',
  'Zoom, pan (two fingers on touch screens)':
    'Zoomen, verschieben (auf Touchscreens mit zwei Fingern)',
  'Fit page':
    'Ganze Seite',
  '＋ Page':
    '＋ Seite',
  'Colors & shopping list':
    'Farben & Einkaufsliste',
  'Piece size':
    'Stückgröße',
  'Waste':
    'Verschnitt',
  '“Replace with” recolors every area of that color.':
    '„Ersetzen durch“ färbt jede Fläche dieser Farbe um.',
  'Download CSV':
    'CSV herunterladen',
  'Print template':
    'Druckvorlage',
  'Opens a print page to use as a cutting or laying template.':
    'Öffnet eine Druckseite, die Sie als Schneide- oder Verlegevorlage verwenden.',
  'Paper':
    'Papier',
  'Letter':
    'Letter',
  'Tabloid (11×17 in)':
    'Tabloid (11×17 Zoll)',
  'Real size (split across several sheets if needed)':
    'Originalgröße (bei Bedarf auf mehrere Blätter verteilt)',
  'Fit on one sheet':
    'Auf ein Blatt einpassen',
  'In color':
    'Farbig',
  'In color, with color numbers':
    'Farbig, mit Farbnummern',
  'Outlines with color numbers (paint by number)':
    'Umrisse mit Farbnummern (Malen nach Zahlen)',
  'Add a page with the color legend':
    'Eine Seite mit der Farblegende hinzufügen',
  'Mosaic from photo':
    'Mosaik aus Foto',
  'Lays out tiles over the whole page and gives each tile the color of the photo underneath it.':
    'Verteilt Fliesen über die ganze Seite und gibt jeder Fliese die Farbe des Fotos darunter.',
  'First load a photo:':
    'Laden Sie zuerst ein Foto:',
  'Tiles':
    'Fliesen',
  'Smaller tiles where the photo has detail':
    'Kleinere Fliesen, wo das Foto Details hat',
  'Use the current palette':
    'Aktuelle Palette verwenden',
  'Suggest':
    'Vorschlagen:',
  'colors from the photo (new palette)':
    'Farben aus dem Foto (neue Palette)',
  'Replace the current drawing (it is kept in History)':
    'Die aktuelle Zeichnung ersetzen (sie bleibt im Verlauf)',
  'Laying plan':
    'Verlegeplan',
  'Splits the mosaic into numbered panels – the size of your work surface or of the mesh sheets you lay the tiles on. The print has an overview, every panel at real size and the number of tiles of each color per panel.':
    'Teilt das Mosaik in nummerierte Felder – so groß wie Ihre Arbeitsfläche oder die Netze, auf die Sie die Fliesen legen. Der Ausdruck enthält eine Übersicht, jedes Feld in Originalgröße und die Anzahl der Fliesen jeder Farbe pro Feld.',
  'Panel size':
    'Feldgröße',
  'Tabloid':
    'Tabloid',
  'Color numbers on the tiles':
    'Farbnummern auf den Fliesen',
  'Show the panels on the drawing':
    'Felder in der Zeichnung anzeigen',
  'The whole drawing is packed into the link itself – nothing is uploaded. Whoever opens it sees the mosaic and can make their own copy to edit.':
    'Die ganze Zeichnung steckt im Link selbst – nichts wird hochgeladen. Wer ihn öffnet, sieht das Mosaik und kann eine eigene Kopie zum Bearbeiten anlegen.',
  'Include the tracing photo (makes the link much longer)':
    'Das Foto zum Nachzeichnen mitnehmen (macht den Link viel länger)',
  'Share file…':
    'Datei teilen…',
  'Copy link':
    'Link kopieren',
  'Switch app':
    'App wechseln',
  'Vector: tiles as shapes. Raster: paint with pixels. Palettes are shared; copy and paste images between them.':
    'Vektor: Fliesen als Formen. Raster: Malen mit Pixeln. Die Paletten sind gemeinsam; Bilder lassen sich zwischen beiden kopieren und einfügen.',
  'Simple shows the essentials; Expert adds symmetry, layers, rulers, the knife, printing and fine settings':
    'Einfach zeigt das Wesentliche; Experte ergänzt Symmetrie, Ebenen, Lineale, das Messer, Drucken und Feineinstellungen',
  'New drawing':
    'Neue Zeichnung',
  'Open SVG (Ctrl+O) – you can also drop a file on the canvas':
    'SVG öffnen (Strg+O) – Sie können eine Datei auch auf die Zeichenfläche ziehen',
  'Save SVG (Ctrl+S)':
    'SVG speichern (Strg+S)',
  'Save as (Ctrl+Shift+S)':
    'Speichern unter (Strg+Umschalt+S)',
  'Export a PNG image':
    'Ein PNG-Bild exportieren',
  'Export a 3D model for printing with filament changes – each color at its own height':
    'Ein 3D-Modell für den Druck mit Filamentwechseln exportieren – jede Farbe auf ihrer eigenen Höhe',
  'Copy the drawing (or the selected shapes) as an image – paste it into the raster app or any other program (Ctrl+C)':
    'Die Zeichnung (oder die ausgewählten Formen) als Bild kopieren – in die Raster-App oder ein anderes Programm einfügen (Strg+C)',
  'Print a real-size template with color numbers':
    'Eine Vorlage in Originalgröße mit Farbnummern drucken',
  'Split the mosaic into numbered panels and print a laying plan':
    'Das Mosaik in nummerierte Felder teilen und einen Verlegeplan drucken',
  'Colors used, areas and a shopping list':
    'Verwendete Farben, Flächen und eine Einkaufsliste',
  'Earlier versions of your drawing':
    'Frühere Versionen Ihrer Zeichnung',
  'Share the mosaic as a link':
    'Das Mosaik als Link teilen',
  'Undo (Ctrl+Z)':
    'Rückgängig (Strg+Z)',
  'Redo (Ctrl+Y)':
    'Wiederholen (Strg+Y)',
  'Zoom out (-)':
    'Verkleinern (-)',
  'Zoom in (+)':
    'Vergrößern (+)',
  'Fit page (0)':
    'Ganze Seite (0)',
  'See the mosaic in black & white or as color-blind people see it (screen only)':
    'Das Mosaik in Schwarzweiß oder so sehen, wie Farbenblinde es sehen (nur auf dem Bildschirm)',
  'Mark tiles that blend into a neighbouring tile of another color':
    'Fliesen markieren, die mit einer Nachbarfliese anderer Farbe verschwimmen',
  'Language':
    'Sprache',
  'Install as an app that also works offline':
    'Als App installieren, die auch offline funktioniert',
  'Show the side panel':
    'Seitenleiste anzeigen',
  'Select / edit (V)':
    'Auswählen / bearbeiten (V)',
  'Line (L)':
    'Linie (L)',
  'Free polygon – click corner by corner (P)':
    'Freies Vieleck – Ecke für Ecke klicken (P)',
  'Regular polygon (G)':
    'Regelmäßiges Vieleck (G)',
  'Knife – cut a tile straight across (K)':
    'Messer – eine Fliese gerade durchschneiden (K)',
  'Pattern – fill an area with tiles (T)':
    'Muster – eine Fläche mit Fliesen füllen (T)',
  'Paint bucket – click or drag across tiles (B)':
    'Farbeimer – klicken oder über Fliesen ziehen (B)',
  'Pan (H, or hold Space / middle mouse / two fingers)':
    'Verschieben (H, oder Leertaste / mittlere Maustaste / zwei Finger halten)',
  'Your saved palettes':
    'Ihre gespeicherten Paletten',
  'New palette':
    'Neue Palette',
  'Rename this palette':
    'Diese Palette umbenennen',
  'Delete this palette':
    'Diese Palette löschen',
  'Fill color – used by the paint bucket':
    'Füllfarbe – für den Farbeimer',
  'Stroke color – used for new lines and polygons':
    'Konturfarbe – für neue Linien und Vielecke',
  'Swap fill and stroke':
    'Füllung und Kontur tauschen',
  'Line width for new lines and polygons':
    'Linienbreite für neue Linien und Vielecke',
  'Paste #hex, rgb(), name…':
    '#hex, rgb(), Name einfügen…',
  'Load colors from a .txt / .gpl / .css file':
    'Farben aus einer .txt- / .gpl- / .css-Datei laden',
  'Add every color used in the drawing':
    'Jede in der Zeichnung verwendete Farbe hinzufügen',
  'Download the palette as a list of hex codes':
    'Die Palette als Liste von Hex-Codes herunterladen',
  '0 = as many rows as fit':
    '0 = so viele Reihen, wie passen',
  'Lay out tiles over the whole page and color them from the photo':
    'Fliesen über die ganze Seite verteilen und nach dem Foto färben',
  'Color the tiles you have drawn':
    'Die gezeichneten Fliesen färben',
  'Grout color':
    'Fugenfarbe',
  'Give every line this color and width for real':
    'Allen Linien wirklich diese Farbe und Breite geben',
  'Save the selected shapes as a motif':
    'Die ausgewählten Formen als Motiv speichern',
  'Load motifs from a file':
    'Motive aus einer Datei laden',
  'Download all motifs as a file':
    'Alle Motive als Datei herunterladen',
  'Give the selected painted areas random colors from the mix':
    'Den ausgewählten bemalten Flächen zufällige Farben aus der Mischung geben',
  'Real-world unit: 1 drawing unit = 1 mm / cm / inch':
    'Reale Einheit: 1 Zeichnungseinheit = 1 mm / cm / Zoll',
  'Add a page (front, back, a color variant…)':
    'Eine Seite hinzufügen (Vorderseite, Rückseite, eine Farbvariante…)',
  'Export…':
    'Exportieren…',
  'Copy':
    'Kopieren',
  'Paste':
    'Einfügen',
  'You are looking at a shared image.':
    'Sie sehen ein geteiltes Bild.',
  'Back to my image':
    'Zurück zu meinem Bild',
  'Place':
    'Platzieren',
  'Paint':
    'Malen',
  'Outline':
    'Kontur',
  'From image':
    'Aus Bild',
  'Click a swatch = paint color · right-click = outline color · double-click = edit (also recolors the image). The ∅ swatch paints transparent. Palettes are shared with the vector app.':
    'Klick auf ein Farbfeld = Malfarbe · Rechtsklick = Konturfarbe · Doppelklick = bearbeiten (färbt auch das Bild um). Das Farbfeld ∅ malt transparent. Die Paletten sind mit der Vektor-App gemeinsam.',
  'Brush':
    'Pinsel',
  'Smooth edges for lines and polygons':
    'Glatte Kanten für Linien und Vielecke',
  'The pencil always paints hard pixels in exact palette colors – best for pixel mosaics. Shift: straight lines in 15° steps.':
    'Der Stift malt immer harte Pixel in exakten Palettenfarben – ideal für Pixelmosaike. Umschalt: gerade Linien in 15°-Schritten.',
  'Fill with the paint color':
    'Mit der Malfarbe füllen',
  'Outline in the outline color':
    'Kontur in der Konturfarbe',
  'Drag from the center. Shift: 15° rotation steps.':
    'Vom Mittelpunkt ziehen. Umschalt: Drehung in 15°-Schritten.',
  'Tolerance':
    'Toleranz',
  'Only connected pixels':
    'Nur zusammenhängende Pixel',
  'Fills the area of similar color under the click. Alt+click picks a color.':
    'Füllt die Fläche ähnlicher Farbe unter dem Klick. Alt+Klick nimmt eine Farbe auf.',
  'Cut':
    'Ausschneiden',
  'Crop':
    'Zuschneiden',
  'Drag inside the selection to move it (Alt+drag moves a copy), a corner to scale it, the knob above it to turn it; two fingers on it scale and turn it. The bar below it turns, flips, duplicates and deletes. Enter places it, Esc cancels.':
    'In der Auswahl ziehen, um sie zu verschieben (Alt+Ziehen verschiebt eine Kopie), an einer Ecke, um sie zu skalieren, am Griff darüber, um sie zu drehen; zwei Finger darauf skalieren und drehen sie. Die Leiste darunter dreht, spiegelt, dupliziert und löscht. Enter platziert sie, Esc bricht ab.',
  'Mosaic':
    'Mosaik',
  'Make a mosaic…':
    'Mosaik erstellen…',
  'Reduce to palette':
    'Auf Palette reduzieren',
  'Open as vector tiles…':
    'Als Vektorfliesen öffnen…',
  'Works on the selection, or on the whole image when nothing is selected.':
    'Wirkt auf die Auswahl oder auf das ganze Bild, wenn nichts ausgewählt ist.',
  'Image':
    'Bild',
  'Resize image':
    'Bildgröße ändern',
  'Canvas size':
    'Leinwandgröße',
  'Pixel grid when zoomed in':
    'Pixelraster beim Vergrößern',
  'Select, Brush, Pencil, Eraser, Line, Polygon, Ellipse, Curve, Bucket, Pick color, Pan':
    'Auswahl, Pinsel, Stift, Radierer, Linie, Vieleck, Ellipse, Kurve, Farbeimer, Pipette, Verschieben',
  'Smaller / bigger brush':
    'Kleinerer / größerer Pinsel',
  'Swap paint and outline colors':
    'Mal- und Konturfarbe tauschen',
  'Alt+click':
    'Alt+Klick',
  'Pick a color':
    'Farbe aufnehmen',
  'Straight lines, 15° steps':
    'Gerade Linien, 15°-Schritte',
  'Copy, cut, paste images (also between the two apps and other programs)':
    'Bilder kopieren, ausschneiden, einfügen (auch zwischen beiden Apps und anderen Programmen)',
  'Select all, clear the selection':
    'Alles auswählen, Auswahl aufheben',
  'Place / cancel a moved or pasted image':
    'Verschobenes oder eingefügtes Bild platzieren / abbrechen',
  'Fit image, actual pixels':
    'Ganzes Bild, tatsächliche Pixel',
  'Real width':
    'Reale Breite',
  'Pieces are areas of one color (tiles). “Replace with” recolors every pixel of that color.':
    'Teile sind Flächen einer Farbe (Fliesen). „Ersetzen durch“ färbt jedes Pixel dieser Farbe um.',
  'The image is packed into the link itself – nothing is uploaded. Whoever opens it sees the image and can make their own copy to edit.':
    'Das Bild steckt im Link selbst – nichts wird hochgeladen. Wer ihn öffnet, sieht das Bild und kann eine eigene Kopie zum Bearbeiten anlegen.',
  'Make a mosaic':
    'Mosaik erstellen',
  'Splits the picture into tiles and gives each tile the color underneath it, with grout between the tiles.':
    'Teilt das Bild in Fliesen, gibt jeder Fliese die Farbe darunter und setzt Fugen zwischen die Fliesen.',
  'Squares':
    'Quadrate',
  'Squares, offset rows':
    'Quadrate, versetzte Reihen',
  'Bricks':
    'Ziegel',
  'Hexagons':
    'Sechsecke',
  'Irregular (crazy paving)':
    'Unregelmäßig (Bruchmosaik)',
  'Grout':
    'Fugen',
  'Smaller tiles where the picture has detail':
    'Kleinere Fliesen, wo das Bild Details hat',
  'colors from the picture (new palette)':
    'Farben aus dem Bild (neue Palette)',
  'Keep the picture’s colors':
    'Die Farben des Bildes beibehalten',
  'Open as vector tiles':
    'Als Vektorfliesen öffnen',
  'Every piece of the picture (an area of one color) becomes a tile shape in the vector app, at the real size – ready for its print templates, laying plan, 3D print and editing. Your current vector drawing is kept in its History.':
    'Jedes Teil des Bildes (eine Fläche einer Farbe) wird in der Vektor-App zu einer Fliesenform in Originalgröße – bereit für Druckvorlagen, Verlegeplan, 3D-Druck und Bearbeitung. Ihre aktuelle Vektorzeichnung bleibt in deren Verlauf.',
  'The grout color becomes the page background; every other piece becomes a tile.':
    'Die Fugenfarbe wird zum Seitenhintergrund; jedes andere Teil wird zu einer Fliese.',
  'Open in the vector app':
    'In der Vektor-App öffnen',
  'Format':
    'Format',
  'JPEG':
    'JPEG',
  'WebP':
    'WebP',
  'Quality':
    'Qualität',
  'JPEG has no transparency: transparent parts become white.':
    'JPEG kennt keine Transparenz: Transparente Stellen werden weiß.',
  'Simple shows the essentials; Expert adds opacity, tolerance, resizing and more':
    'Einfach zeigt das Wesentliche; Experte ergänzt Deckkraft, Toleranz, Größenänderung und mehr',
  'New image':
    'Neues Bild',
  'Open an image (Ctrl+O) – you can also drop one on the canvas':
    'Ein Bild öffnen (Strg+O) – Sie können es auch auf die Zeichenfläche ziehen',
  'Save as PNG (Ctrl+S)':
    'Als PNG speichern (Strg+S)',
  'Export as JPEG or WebP':
    'Als JPEG oder WebP exportieren',
  'Colors used, pieces and a shopping list':
    'Verwendete Farben, Teile und eine Einkaufsliste',
  'Earlier versions of your image':
    'Frühere Versionen Ihres Bildes',
  'Share the image as a link':
    'Das Bild als Link teilen',
  'Copy the selection (or the whole image) to the clipboard (Ctrl+C)':
    'Die Auswahl (oder das ganze Bild) in die Zwischenablage kopieren (Strg+C)',
  'Paste an image from the clipboard (Ctrl+V)':
    'Ein Bild aus der Zwischenablage einfügen (Strg+V)',
  'Fit image (0)':
    'Ganzes Bild (0)',
  'Actual pixels (1)':
    'Tatsächliche Pixel (1)',
  'Select – drag a rectangle, then drag it to move (V)':
    'Auswahl – ein Rechteck aufziehen, dann zum Verschieben ziehen (V)',
  'Brush – soft edges (B)':
    'Pinsel – weiche Kanten (B)',
  'Pencil – hard pixels in exact colors (P)':
    'Stift – harte Pixel in exakten Farben (P)',
  'Eraser (E)':
    'Radierer (E)',
  'Paint bucket – fill an area (F)':
    'Farbeimer – eine Fläche füllen (F)',
  'Pick a color (I, or Alt+click with any paint tool)':
    'Farbe aufnehmen (I, oder Alt+Klick mit jedem Malwerkzeug)',
  'Your saved palettes (shared with the vector app)':
    'Ihre gespeicherten Paletten (gemeinsam mit der Vektor-App)',
  'Paint color – brush, pencil, lines, polygons and the bucket':
    'Malfarbe – Pinsel, Stift, Linien, Vielecke und Farbeimer',
  'Outline color – the outline of polygons':
    'Konturfarbe – die Kontur von Vielecken',
  'Swap paint and outline colors (X)':
    'Mal- und Konturfarbe tauschen (X)',
  'Brush, pencil, eraser and line size in pixels ( [ and ] )':
    'Größe von Pinsel, Stift, Radierer und Linie in Pixeln ( [ und ] )',
  'Add the colors used in the image (or suggest some for a photo)':
    'Die im Bild verwendeten Farben hinzufügen (oder für ein Foto welche vorschlagen)',
  'Turn the image (or the selection) into tiles with grout':
    'Das Bild (oder die Auswahl) in Fliesen mit Fugen verwandeln',
  'Give every pixel the closest palette color':
    'Jedem Pixel die nächstliegende Palettenfarbe geben',
  'Every tile becomes a shape in the vector app – for its templates, laying plan and editing':
    'Jede Fliese wird zu einer Form in der Vektor-App – für deren Vorlagen, Verlegeplan und Bearbeitung',
  'Scale the picture to this size':
    'Das Bild auf diese Größe skalieren',
  'Change the canvas size, keeping the picture centered':
    'Die Leinwandgröße ändern, das Bild bleibt zentriert',
  'The width of the finished mosaic':
    'Die Breite des fertigen Mosaiks',
  'Herringbone':
    'Fischgrät',
  'Triangles':
    'Dreiecke',
  'Rings (around the click)':
    'Ringe (um den Klick)',
  'Rows following the outline':
    'Reihen entlang der Kontur',
  'portrait':
    'Hochformat',
  'landscape':
    'Querformat',
  'Vector':
    'Vektor',
  'Raster':
    'Raster',
  'Fit':
    'Alles',
  'Thinnest part':
    'Dünnste Stelle',
  'Raised parts narrower than this – or more than twice as tall as they are wide – are lowered to what is around them, so nothing prints as a thin tower':
    'Erhöhte Stellen, die schmaler sind – oder mehr als doppelt so hoch wie breit –, werden auf die Umgebung abgesenkt, damit nichts als dünner Turm gedruckt wird',
  'Grout colors are always printed first, so the lines between the tiles stay low.':
    'Fugenfarben werden immer zuerst gedruckt, damit die Linien zwischen den Fliesen niedrig bleiben.',
  'Grout / lines: always printed first, so they stay low':
    'Fugen / Linien: werden immer zuerst gedruckt und bleiben deshalb niedrig',
  'grout':
    'Fuge',
  '{n} thin {n|piece|pieces} lowered so nothing prints as a thin tower':
    '{n} {n|dünnes Teil|dünne Teile} abgesenkt, damit nichts als dünner Turm gedruckt wird',
  'Top view':
    'Draufsicht',
  'Drag to turn · wheel or two fingers to zoom · double-click to reset':
    'Ziehen zum Drehen · Mausrad oder zwei Finger zum Zoomen · Doppelklick setzt zurück',
  'Shows the heights taller than they are, to see the color bands':
    'Zeigt die Höhen überhöht, damit die Farbschichten sichtbar werden',
  'Heights ×':
    'Höhen ×',
  'This browser can’t show 3D (WebGL is off).':
    'Dieser Browser kann kein 3D anzeigen (WebGL ist aus).',
  'One nozzle – colors by height':
    'Eine Düse – Farben nach Höhe',
  'Several filaments (AMS, MMU…) – flat':
    'Mehrere Filamente (AMS, MMU…) – flach',
  'A flat model with one part per color, for printers that switch filaments by themselves. The 3MF file already assigns filament 1, 2, … to the parts – load the filaments in the order listed below.':
    'Ein flaches Modell mit einem Teil pro Farbe, für Drucker, die Filamente selbst wechseln. Die 3MF-Datei ordnet den Teilen bereits Filament 1, 2, … zu – legen Sie die Filamente in der unten genannten Reihenfolge ein.',
  'How thick the tiles are above the base':
    'Wie dick die Fliesen über der Basis sind',
  'Tile layers':
    'Fliesenschichten',
  'Grout colors end this many layers below the tiles, so the lines between them stay low. 0: all flat':
    'Fugenfarben enden so viele Schichten unter den Fliesen, damit die Linien dazwischen niedrig bleiben. 0: alles flach',
  'Grout lower by':
    'Fugen tiefer um',
  'layers':
    'Schichten',
  'Filaments:':
    'Filamente:',
  'Grout colors come first and stay lower than the tiles. The base plate uses filament 1.':
    'Fugenfarben kommen zuerst und bleiben niedriger als die Fliesen. Die Basisplatte nutzt Filament 1.',
  '3MF for':
    '3MF für',
  'The model, one part per color with its filament':
    'Das Modell, ein Teil pro Farbe mit seinem Filament',
  'One STL file per color, in a ZIP – load them as parts of one object':
    'Eine STL-Datei pro Farbe in einem ZIP – als Teile eines Objekts laden',
  '{share} % · filament {k}':
    '{share} % · Filament {k}',
  '{n} {n|color|colors} = {n} {n|filament|filaments} · flat, {h} mm high ({layers} {layers|layer|layers})':
    '{n} {n|Farbe|Farben} = {n} {n|Filament|Filamente} · flach, {h} mm hoch ({layers} {layers|Schicht|Schichten})',
  'Base':
    'Basis',
  'Mosaic Paint – multi-filament plan for {name}.3mf':
    'Mosaic Paint – Mehrfilament-Plan für {name}.3mf',
  'Size {w} × {h} mm · layer height {lh} mm · base {base} {base|layer|layers} · tiles {tile} {tile|layer|layers} · grout {recess} {recess|layer|layers} lower':
    'Größe {w} × {h} mm · Schichthöhe {lh} mm · Basis {base} {base|Schicht|Schichten} · Fliesen {tile} {tile|Schicht|Schichten} · Fugen {recess} {recess|Schicht|Schichten} tiefer',
  'Total height {total} mm.':
    'Gesamthöhe {total} mm.',
  'Filament {k}: {color} (also the base plate)':
    'Filament {k}: {color} (auch die Basisplatte)',
  'Filament {k}: {color}':
    'Filament {k}: {color}',
  '{slicer}: open the 3MF – every color is a part of one object with its filament already assigned. Load the filaments in this order (AMS slots, MMU…).':
    '{slicer}: Öffnen Sie die 3MF – jede Farbe ist ein Teil eines Objekts, dem sein Filament bereits zugeordnet ist. Legen Sie die Filamente in dieser Reihenfolge ein (AMS-Slots, MMU…).',
  'The 3MF is made for {slicer}: other slicers may read it as one part – then use the STL files.':
    'Die 3MF ist für {slicer} gemacht: Andere Slicer lesen sie eventuell als ein Teil – dann nehmen Sie die STL-Dateien.',
  'STL: one file per color in a ZIP. Load them together as one object made of parts and give each its filament.':
    'STL: eine Datei pro Farbe in einem ZIP. Laden Sie sie zusammen als ein Objekt aus Teilen und geben Sie jedem sein Filament.',
  'Saved {name}.3mf for {slicer}: {n} {n|part|parts} with their filaments assigned.':
    '{name}.3mf für {slicer} gespeichert: {n} {n|Teil|Teile} mit zugeordneten Filamenten.',
  'Saved {name}-stl.zip: {n} STL {n|file|files}, one per color. Load them as parts of one object.':
    '{name}-stl.zip gespeichert: {n} STL-{n|Datei|Dateien}, eine pro Farbe. Als Teile eines Objekts laden.',
  'Finishing: frame, corners, hanging hole, magnets':
    'Feinschliff: Rahmen, Ecken, Aufhängeloch, Magnete',
  'A border around the picture. With one nozzle it comes out in the top color, with several filaments in filament 1. 0: none':
    'Ein Rand um das Bild. Mit einer Düse wird er in der obersten Farbe gedruckt, mit mehreren Filamenten in Filament 1. 0: keiner',
  'Frame':
    'Rahmen',
  'How many layers the frame stands above the tiles':
    'Wie viele Schichten der Rahmen über die Fliesen hinausragt',
  'raised by':
    'höher um',
  'Radius of the outline’s corners. 0: square':
    'Radius der Ecken des Umrisses. 0: eckig',
  'Rounded corners':
    'Abgerundete Ecken',
  'A hole to hang it by, at the top in the middle. 0: none':
    'Ein Loch zum Aufhängen, oben in der Mitte. 0: keines',
  'Hanging hole':
    'Aufhängeloch',
  'Four round pockets in the bottom, one near each corner, to glue magnets in: their diameter. 0: none':
    'Vier runde Vertiefungen in der Unterseite, eine an jeder Ecke, zum Einkleben von Magneten: ihr Durchmesser. 0: keine',
  'Magnets':
    'Magnete',
  'How deep the magnet pockets are (the magnet’s thickness)':
    'Wie tief die Magnetvertiefungen sind (die Dicke des Magneten)',
  'deep':
    'tief',
  'with the frame {w} × {h} mm, {z} mm high':
    'mit Rahmen {w} × {h} mm, {z} mm hoch',
  'The model is too thin for magnet pockets.':
    'Das Modell ist für Magnetvertiefungen zu dünn.',
  'The magnet pockets are only {d} mm deep – the model is thinner there.':
    'Die Magnetvertiefungen sind nur {d} mm tief – das Modell ist dort dünner.',
  'Frame {w} mm wide, up to layer {layer} (Z {z} mm), in filament 1.':
    'Rahmen {w} mm breit, bis Schicht {layer} (Z {z} mm), in Filament 1.',
  'Frame {w} mm wide: it goes on in {color} up to layer {layer} (Z {z} mm).':
    'Rahmen {w} mm breit: Er geht in {color} weiter bis Schicht {layer} (Z {z} mm).',
  'Magnet pockets in the bottom: 4 × {d} mm, {depth} mm deep – glue the magnets in after printing.':
    'Magnetvertiefungen in der Unterseite: 4 × {d} mm, {depth} mm tief – kleben Sie die Magnete nach dem Druck ein.',
  'Making the mosaic…':
    'Mosaik wird erstellt…',
  'Could not make the mosaic.':
    'Das Mosaik konnte nicht erstellt werden.',
  'Tracing the tiles…':
    'Fliesen werden nachgezeichnet…',
  'Could not trace the tiles.':
    'Die Fliesen konnten nicht nachgezeichnet werden.',
  'Working out the model…':
    'Modell wird berechnet…',
  'Working out the model… {p} %':
    'Modell wird berechnet… {p} %',
  'Could not build the 3D model.':
    'Das 3D-Modell konnte nicht erstellt werden.',
  'Building the 3D model…':
    '3D-Modell wird erstellt…',
  'Building the 3D model… {p} %':
    '3D-Modell wird erstellt… {p} %',
  'Coaster':
    'Untersetzer',
  'HOME':
    'HEIM',
  'Sign':
    'Schild',
  '100 × 100 mm, square tiles in rings of color – try 3D… with rounded corners.':
    '100 × 100 mm, quadratische Fliesen in Farbringen – probieren Sie 3D… mit abgerundeten Ecken.',
  'coaster':
    'untersetzer',
  'A word in tiles with a border – try Report for a shopping list.':
    'Ein Wort aus Fliesen mit Rand – unter Übersicht finden Sie eine Einkaufsliste.',
  'sign':
    'schild',
  'Welcome to Mosaic Paint':
    'Willkommen bei Mosaic Paint',
  'Design a mosaic: draw lines or lay a tile pattern, then paint the tiles. Everything is measured in real millimetres.':
    'Entwerfen Sie ein Mosaik: Zeichnen Sie Linien oder legen Sie ein Fliesenmuster und bemalen Sie dann die Fliesen. Alles wird in echten Millimetern gemessen.',
  'Draw':
    'Zeichnen',
  'The tools are on the left: lines and shapes, the tile pattern, and the paint bucket that fills a tile with one click.':
    'Die Werkzeuge sind links: Linien und Formen, das Fliesenmuster und der Farbeimer, der eine Fliese mit einem Klick füllt.',
  'Pick a color in the palette, then click tiles with the bucket. Palettes are shared with the raster app.':
    'Wählen Sie eine Farbe in der Palette und klicken Sie mit dem Farbeimer auf Fliesen. Die Paletten sind mit der Raster-App gemeinsam.',
  'When it is done':
    'Wenn es fertig ist',
  'Report gives a shopping list, 3D… a model to print, Share a link. Expert mode adds printing at real size and laying plans.':
    'Übersicht liefert eine Einkaufsliste, 3D… ein Modell zum Drucken, Teilen einen Link. Der Expertenmodus ergänzt Drucken in Originalgröße und Verlegepläne.',
  'Start from an example':
    'Mit einem Beispiel beginnen',
  'Not sure where to begin? Open an example. The ? button shows this guide again.':
    'Nicht sicher, wo Sie anfangen sollen? Öffnen Sie ein Beispiel. Die Schaltfläche ? zeigt diese Anleitung erneut.',
  'Pixel heart':
    'Pixelherz',
  '16 × 16 pixel art – every pixel a tile. Try 3D… or Print.':
    '16 × 16 Pixel-Art – jedes Pixel eine Fliese. Probieren Sie 3D… oder Drucken.',
  'heart':
    'herz',
  'Heart':
    'Herz',
  'Sunset mosaic':
    'Sonnenuntergang-Mosaik',
  'A picture made into tiles with grout by “Make a mosaic…”. Try Open as vector tiles.':
    'Ein Bild, das mit „Mosaik erstellen…“ zu Fliesen mit Fugen wurde. Probieren Sie „Als Vektorfliesen öffnen“.',
  'sunset':
    'sonnenuntergang',
  'Sunset':
    'Sonnenuntergang',
  'Welcome to Mosaic Paint Raster':
    'Willkommen bei Mosaic Paint Raster',
  'Paint with pixels: pixel art, or a photo turned into a mosaic. Each pixel can become a tile.':
    'Malen Sie mit Pixeln: Pixel-Art oder ein Foto als Mosaik. Jedes Pixel kann eine Fliese werden.',
  'The tools are on the left: pencil, brush, bucket, lines, shapes and selection.':
    'Die Werkzeuge sind links: Stift, Pinsel, Farbeimer, Linien, Formen und Auswahl.',
  'Pick a color in the palette. Palettes are shared with the vector app.':
    'Wählen Sie eine Farbe in der Palette. Die Paletten sind mit der Vektor-App gemeinsam.',
  'Open a photo, then “Make a mosaic…” turns it into tiles with grout in your palette’s colors.':
    'Öffnen Sie ein Foto, dann macht „Mosaik erstellen…“ daraus Fliesen mit Fugen in den Farben Ihrer Palette.',
  'Examples':
    'Beispiele',
  'Open an example to see how it is made, or to start from it. Your current work is kept in History.':
    'Öffnen Sie ein Beispiel, um zu sehen, wie es gemacht ist, oder um darauf aufzubauen. Ihre aktuelle Arbeit bleibt im Verlauf.',
  'Back':
    'Zurück',
  '{k} of {n}':
    '{k} von {n}',
  'Next':
    'Weiter',
  'Examples…':
    'Beispiele…',
  'Example projects to open':
    'Beispielprojekte zum Öffnen',
  'A short guide to the app':
    'Eine kurze Anleitung zur App',
  'Guide':
    'Anleitung',
  'Working… {p} %':
    'Arbeite… {p} %',
  'Your photo':
    'Ihr Foto',
  'Load a photo and turn it into tiles – smaller where it has detail.':
    'Laden Sie ein Foto und machen Sie Fliesen daraus – kleinere, wo es Details hat.',
  'Read the G-code your slicer made and check it against this plan: filament changes, filaments and heights':
    'Den G-Code Ihres Slicers lesen und mit diesem Plan vergleichen: Filamentwechsel, Filamente und Höhen',
  'Check G-code…':
    'G-Code prüfen…',
  'Change to {color} at Z {z} mm':
    'Wechsel zu {color} bei Z {z} mm',
  'No filament change to {color} at Z {z} mm':
    'Kein Filamentwechsel zu {color} bei Z {z} mm',
  'A filament change the plan does not have, at Z {z} mm':
    'Ein Filamentwechsel, den der Plan nicht hat, bei Z {z} mm',
  'The top is at {z} mm, as planned':
    'Die Oberkante liegt wie geplant bei {z} mm',
  'The top is at {found} mm instead of {z} mm':
    'Die Oberkante liegt bei {found} mm statt bei {z} mm',
  'Filament {k} ({color}) is not used – assign it to the part “{k} {color}”':
    'Filament {k} ({color}) wird nicht verwendet – ordnen Sie es dem Teil „{k} {color}“ zu',
  'Filament {k} ({color}) prints up to {z} mm':
    'Filament {k} ({color}) druckt bis {z} mm',
  'Filament {k} ({color}) prints up to {found} mm instead of {z} mm':
    'Filament {k} ({color}) druckt bis {found} mm statt bis {z} mm',
  'No printing found in {name} – is it a G-code file?':
    'In {name} wird nichts gedruckt – ist das eine G-Code-Datei?',
  '{name}: {n} {n|thing|things} to look at':
    '{name}: {n} {n|Punkt|Punkte} zu prüfen',
  '{name}: everything matches the plan':
    '{name}: alles passt zum Plan',
  'Reading the G-code…':
    'G-Code wird gelesen…',
  'Reading the G-code… {p} %':
    'G-Code wird gelesen… {p} %',
  'Could not read {name}.':
    '{name} lässt sich nicht lesen.',
  '{name} is {w} × {h} px – painting on it and making mosaics will be slow. Scale it down to {W} × {H} px?':
    '{name} ist {w} × {h} px groß – Malen und Mosaike darauf werden langsam. Auf {W} × {H} px verkleinern?',
  'It has many colors: “Reduce to palette” or “Make a mosaic…” turn them into a few you can buy tiles in.':
    'Es hat viele Farben: „Auf Palette reduzieren“ oder „Mosaik erstellen…“ machen daraus wenige, in denen Sie Fliesen kaufen können.',
  '{n} {n|color|colors}':
    '{n} {n|Farbe|Farben}',
  'Unpin – it may be cleared with old versions':
    'Lösen – kann mit alten Versionen gelöscht werden',
  'Pin – kept when old versions are cleared':
    'Anheften – bleibt, wenn alte Versionen gelöscht werden',
  'Name this version':
    'Diese Version benennen',
  'Name of this version:':
    'Name dieser Version:',
  'Share link':
    'Link zum Teilen',
  'What’s new':
    'Neuigkeiten',
  'Version {v} – what’s new':
    'Version {v} – Neuigkeiten',
  'Updated to version {v} – click v{v} in the corner to see what’s new.':
    'Auf Version {v} aktualisiert – klicken Sie unten in der Ecke auf v{v}, um die Neuigkeiten zu sehen.',
  'The raster app: paint with pixels, turn photos into mosaics, and copy pictures between both apps.':
    'Die Raster-App: Malen mit Pixeln, Fotos als Mosaik und Bilder zwischen beiden Apps kopieren.',
  '3D print: a 3D preview, models for multi-filament printers (AMS, MMU), a frame, rounded corners, a hanging hole and magnet pockets – and a check of the sliced G-code against the plan.':
    '3D-Druck: eine 3D-Vorschau, Modelle für Mehrfilament-Drucker (AMS, MMU), ein Rahmen, abgerundete Ecken, ein Aufhängeloch und Magnetvertiefungen – und eine Prüfung des G-Codes aus dem Slicer gegen den Plan.',
  'Examples to start from, and a short guide for newcomers.':
    'Beispiele zum Loslegen und eine kurze Anleitung für Einsteiger.',
  'German, Slovak and Polish.':
    'Deutsch, Slowakisch und Polnisch.',
  'Heavy work – mosaics, tracing, 3D models – no longer holds up the page.':
    'Aufwendige Arbeit – Mosaike, Nachzeichnen, 3D-Modelle – hält die Seite nicht mehr auf.',
  'History: name and pin versions; see their size and colors.':
    'Verlauf: Versionen benennen und anheften; ihre Größe und Farben sehen.',
  'Big images can be scaled down when opened.':
    'Große Bilder lassen sich beim Öffnen verkleinern.',
  'Better keyboard and screen-reader support.':
    'Bessere Unterstützung für Tastatur und Bildschirmleser.',
  'The vector editor: lines, tile patterns, the paint bucket, palettes, reports, printing at real size and sharing as a link.':
    'Der Vektor-Editor: Linien, Fliesenmuster, der Farbeimer, Paletten, Übersichten, Drucken in Originalgröße und Teilen per Link.',
  'Could not sign in to Discord.':
    'Anmeldung bei Discord fehlgeschlagen.',
  'Post to the channel':
    'In den Kanal posten',
  'Post the picture in this channel, as a reply to the message it came from':
    'Das Bild in diesem Kanal posten, als Antwort auf die Nachricht, aus der es stammt',
  'That image is no longer available in Discord.':
    'Dieses Bild ist in Discord nicht mehr verfügbar.',
  'Right-click an image in the chat › Apps › Edit image to edit it here – or open or paste one.':
    'Rechtsklick auf ein Bild im Chat › Apps › Edit image, um es hier zu bearbeiten – oder öffnen oder fügen Sie eines ein.',
  'Posted to the channel.':
    'In den Kanal gepostet.',
  'The picture is too big for Discord – make it smaller (Image › Resize image).':
    'Das Bild ist zu groß für Discord – verkleinern Sie es (Bild › Bildgröße ändern).',
  'Could not reach the server.':
    'Der Server ist nicht erreichbar.',
  'Could not connect to Discord.':
    'Keine Verbindung zu Discord.',
  'Open the editor with “Edit image” (or the app’s launch button) in this chat to post here – or use Copy and paste the picture.':
    'Öffnen Sie den Editor mit „Edit image“ (oder der Startschaltfläche der App) in diesem Chat, um hier zu posten – oder nutzen Sie Kopieren und fügen Sie das Bild ein.',
  'More than 15 minutes have passed, and Discord no longer lets the app post. Use Copy and paste the picture into the chat.':
    'Es sind mehr als 15 Minuten vergangen, und Discord lässt die App nicht mehr posten. Nutzen Sie Kopieren und fügen Sie das Bild in den Chat ein.',
  'Discord did not take the picture. Use Copy and paste it into the chat.':
    'Discord hat das Bild nicht angenommen. Nutzen Sie Kopieren und fügen Sie es in den Chat ein.',
  'Select the part to keep with the Select tool (V), then crop.':
    'Wählen Sie mit dem Auswahlwerkzeug (V) den Teil aus, der bleiben soll, und schneiden Sie dann zu.',
  'The image is all one color – nothing to trim.':
    'Das Bild ist ganz einfarbig – nichts zum Beschneiden.',
  'There is no border to trim.':
    'Es gibt keinen Rand zum Beschneiden.',
  'Trimmed to {w} × {h} px.':
    'Auf {w} × {h} px beschnitten.',
  'Pen pressure changes the size':
    'Stiftdruck ändert die Größe',
  'Tip':
    'Spitze',
  'Round':
    'Rund',
  'Soft (airbrush)':
    'Weich (Airbrush)',
  'Spray':
    'Sprühdose',
  'Calligraphy':
    'Kalligrafie',
  'Chalk':
    'Kreide',
  'The shape of the brush and eraser':
    'Die Form von Pinsel und Radierer',
  'The angle of the calligraphy nib – 45° for right-handed writing, about 135° for left-handed':
    'Der Winkel der Kalligrafiefeder – 45° für Rechtshänder, etwa 135° für Linkshänder',
  'curve through points':
    'Kurve durch Punkte',
  'B-spline':
    'B-Spline',
  'cubic Bézier':
    'kubische Bézierkurve',
  'quadratic Bézier':
    'quadratische Bézierkurve',
  'ellipse':
    'Ellipse',
  'Drag from corner to corner (or from the center) · Shift: a circle · Alt: no snap':
    'Von Ecke zu Ecke ziehen (oder vom Mittelpunkt) · Umschalt: ein Kreis · Alt: ohne Einrasten',
  'Click the curve’s points · click the first point to close it · double-click or Enter ends it open · Backspace removes the last point · Esc cancels':
    'Die Punkte der Kurve anklicken · Klick auf den ersten Punkt schließt sie · Doppelklick oder Eingabe beendet sie offen · Rücktaste entfernt den letzten Punkt · Esc bricht ab',
  'Turn on “Fill” or “Outline” for shapes.':
    'Schalten Sie bei Formen „Füllung“ oder „Kontur“ ein.',
  'Drag from corner to corner (or from the center) · Shift: a circle':
    'Von Ecke zu Ecke ziehen (oder vom Mittelpunkt) · Umschalt: ein Kreis',
  'The curve runs smoothly through every point you click.':
    'Die Kurve verläuft glatt durch jeden Punkt, den Sie anklicken.',
  'The curve is pulled towards each point but only touches the first and the last – very smooth, good for flowing lines.':
    'Jeder Punkt zieht die Kurve an, sie berührt aber nur den ersten und den letzten – sehr glatt, gut für fließende Linien.',
  'Click a point, two control points, the next point, two control points … The curve passes through every third point; the control points (round) pull it.':
    'Klicken Sie einen Punkt, zwei Kontrollpunkte, den nächsten Punkt, zwei Kontrollpunkte … Die Kurve geht durch jeden dritten Punkt; die Kontrollpunkte (rund) ziehen sie an.',
  'Click a point, a control point, the next point, a control point … The curve passes through every other point; the control points (round) pull it.':
    'Klicken Sie einen Punkt, einen Kontrollpunkt, den nächsten Punkt, einen Kontrollpunkt … Die Kurve geht durch jeden zweiten Punkt; die Kontrollpunkte (rund) ziehen sie an.',
  'Ellipse':
    'Ellipse',
  'From corner':
    'Von der Ecke',
  'Shift: a circle. Select it to drag its axis ends.':
    'Umschalt: ein Kreis. Ausgewählt lassen sich die Enden ihrer Achsen ziehen.',
  'Curve':
    'Kurve',
  'Type':
    'Art',
  'Smooth, through the points':
    'Glatt, durch die Punkte',
  'Smooth, near the points (B-spline)':
    'Glatt, nahe den Punkten (B-Spline)',
  'Bézier, cubic':
    'Bézier, kubisch',
  'Bézier, quadratic':
    'Bézier, quadratisch',
  'Ellipse – Shift: circle (O)':
    'Ellipse – Umschalt: Kreis (O)',
  'Curve – click its points (C)':
    'Kurve – ihre Punkte anklicken (C)',
  'Shift: a circle.':
    'Umschalt: ein Kreis.',
  'An open curve is a line in the paint color, as thick as the size; a closed one is filled and outlined like the shapes.':
    'Eine offene Kurve ist eine Linie in der Malfarbe, so dick wie die Größe; eine geschlossene wird wie die Formen gefüllt und umrandet.',
  'Ellipses and curves in both apps: the Ellipse tool (O, Shift for a circle) and the Curve tool (C) – smooth through the points, smooth near them (B-spline), or cubic and quadratic Bézier.':
    'Ellipsen und Kurven in beiden Apps: das Werkzeug Ellipse (O, mit Umschalt ein Kreis) und das Werkzeug Kurve (C) – glatt durch die Punkte, glatt nahe den Punkten (B-Spline) oder kubische und quadratische Bézierkurve.',
  'In the vector app, ellipses and curves stay exact curves: drag their points or axis ends to change them, and paint, cut and mirror them like any tile.':
    'In der Vektor-App bleiben Ellipsen und Kurven exakte Kurven: Ziehen Sie ihre Punkte oder Achsenenden, um sie zu ändern, und malen, schneiden und spiegeln Sie sie wie jede Fliese.',
  'Shift+B':
    'Umschalt+B',
  'Next brush tip':
    'Nächste Pinselspitze',
  'Brush tip: {tip}':
    'Pinselspitze: {tip}',
  'Brush tips for the brush and the eraser: soft (airbrush), spray, calligraphy and chalk. Shift+B switches between them.':
    'Spitzen für Pinsel und Radierer: weich (Airbrush), Sprühdose, Kalligrafie und Kreide. Umschalt+B wechselt zwischen ihnen.',
  'The spray keeps spraying while you hold it still, like an airbrush; the calligraphy nib’s angle can be set (also for left-handed writing).':
    'Die Sprühdose sprüht weiter, während Sie sie still halten, wie eine Airbrush; der Winkel der Kalligrafiefeder lässt sich einstellen (auch für Linkshänder).',
  'Keep proportions':
    'Seitenverhältnis beibehalten',
  'Flip ↔':
    'Spiegeln ↔',
  'Flip ↕':
    'Spiegeln ↕',
  'Rotate by':
    'Drehen um',
  'Rotate':
    'Drehen',
  'Crop to selection':
    'Auf Auswahl zuschneiden',
  'Trim edges':
    'Ränder beschneiden',
  'With a graphics tablet or stylus, the brush, pencil and eraser paint thinner the lighter you press':
    'Mit einem Grafiktablett oder Stift malen Pinsel, Stift und Radierer umso dünner, je leichter Sie drücken',
  'Rotate 90° to the left':
    'Um 90° nach links drehen',
  'Rotate 90° to the right':
    'Um 90° nach rechts drehen',
  'Flip left ↔ right':
    'Links ↔ rechts spiegeln',
  'Flip upside down':
    'Auf den Kopf stellen',
  'Rotate by any angle (clockwise; negative: to the left) – the canvas grows to hold the picture':
    'Um einen beliebigen Winkel drehen (im Uhrzeigersinn; negativ: nach links) – die Leinwand wächst mit',
  'Keep only the selection (select it with the Select tool first)':
    'Nur die Auswahl behalten (zuerst mit dem Auswahlwerkzeug auswählen)',
  'Cut off the empty or one-color border around the picture':
    'Den leeren oder einfarbigen Rand um das Bild abschneiden',
  'Edit images from a Discord chat: right-click › Apps › Edit image, draw on it, post it back – in the raster or the vector app.':
    'Bilder aus einem Discord-Chat bearbeiten: Rechtsklick › Apps › Edit image, darauf zeichnen, zurückposten – in der Raster- oder der Vektor-App.',
  'Pen pressure: with a graphics tablet or stylus, the brush, pencil and eraser paint thinner the lighter you press.':
    'Stiftdruck: Mit einem Grafiktablett oder Stift malen Pinsel, Stift und Radierer umso dünner, je leichter Sie drücken.',
  'Image editing in the raster app: rotate (by 90° or any angle), flip, crop to the selection, trim the border, resize keeping proportions.':
    'Bildbearbeitung in der Raster-App: drehen (um 90° oder einen beliebigen Winkel), spiegeln, auf die Auswahl zuschneiden, den Rand beschneiden, Größe mit Seitenverhältnis ändern.',
  'Choose a color':
    'Farbe wählen',
  'Saturation and brightness':
    'Sättigung und Helligkeit',
  'Hue':
    'Farbton',
  'Before':
    'Vorher',
  'Color code':
    'Farbcode',
  'Also add it to the palette':
    'Auch zur Palette hinzufügen',
  'Use this color':
    'Diese Farbe verwenden',
  'Choose…':
    'Wählen…',
  'Choose any color: a color area, a hue slider and a color code':
    'Beliebige Farbe wählen: Farbfläche, Farbton-Regler und Farbcode',
  'Fill color – used by the paint bucket. Click to choose any color':
    'Füllfarbe – für den Farbeimer. Klicken, um eine beliebige Farbe zu wählen',
  'Stroke color – used for new lines and polygons. Click to choose any color':
    'Linienfarbe – für neue Linien und Polygone. Klicken, um eine beliebige Farbe zu wählen',
  'Paint color – brush, pencil, lines, polygons and the bucket. Click to choose any color':
    'Malfarbe – Pinsel, Stift, Linien, Polygone und Farbeimer. Klicken, um eine beliebige Farbe zu wählen',
  'Outline color – the outline of polygons. Click to choose any color':
    'Umrissfarbe – der Umriss von Polygonen. Klicken, um eine beliebige Farbe zu wählen',
  'Choose any color: a color area, a hue slider and a color code (Choose… under the palette, or click the current colors).':
    'Beliebige Farbe wählen: Farbfläche, Farbton-Regler und Farbcode (Wählen… unter der Palette, oder auf die aktuellen Farben klicken).',
  'Inside Discord: New, Save as, renaming and the other questions work (they are asked in the page now), and switching between the apps keeps the Post button.':
    'In Discord: Neu, Speichern unter, Umbenennen und die anderen Fragen funktionieren (sie werden jetzt auf der Seite gestellt), und beim Wechsel zwischen den Apps bleibt die Schaltfläche zum Posten erhalten.',
  'On phones inside Discord, the top bar stays clear of Discord’s own controls.':
    'Auf Handys in Discord bleibt die obere Leiste frei von Discords eigenen Bedienelementen.',
  'Quick menu':
    'Schnellmenü',
  'Undo':
    'Rückgängig',
  'Redo':
    'Wiederholen',
  'Fit to the screen':
    'An den Bildschirm anpassen',
  'Which color':
    'Welche Farbe',
  'Choose any color':
    'Beliebige Farbe wählen',
  'The palette is empty – use + to choose a color.':
    'Die Palette ist leer – mit + eine Farbe wählen.',
  'Tip: double-tap the drawing for a quick menu – tools, colors and size.':
    'Tipp: Zweimal auf die Zeichnung tippen öffnet ein Schnellmenü – Werkzeuge, Farben und Größe.',
  'Quick menu on phones and tablets: double-tap the drawing with a finger for undo, the main tools, colors and size – right where you draw.':
    'Schnellmenü auf Handys und Tablets: zweimal mit dem Finger auf die Zeichnung tippen – Rückgängig, die wichtigsten Werkzeuge, Farben und Größe, genau dort, wo du zeichnest.',
  'Tap or click where to copy from.':
    'Tippe oder klicke dorthin, wovon kopiert werden soll.',
  'Tap the image where to copy from':
    'Tippe ins Bild, wovon kopiert werden soll',
  'Copying from {x}, {y}':
    'Kopiert von {x}, {y}',
  'No source yet: the first tap sets it':
    'Noch keine Quelle: das erste Tippen legt sie fest',
  'Source set – now paint where the copy goes.':
    'Quelle gesetzt – jetzt dort malen, wo die Kopie hin soll.',
  'Clone':
    'Klonen',
  'Set source':
    'Quelle festlegen',
  'Aligned – the source follows the brush':
    'Ausgerichtet – die Quelle folgt dem Pinsel',
  'Set where to copy from, then paint where the copy should go. Drag the source disc to move it. Size, tip and opacity are the brush\'s.':
    'Lege fest, wovon kopiert wird, und male dann dort, wo die Kopie hin soll. Die Quellscheibe lässt sich ziehen. Größe, Spitze und Deckkraft sind die des Pinsels.',
  'Clone – paint with a copy of another part of the image · Alt+click or the first tap sets where to copy from (S)':
    'Klonen – mit einer Kopie eines anderen Bildteils malen · Alt+Klick oder das erste Tippen legt fest, wovon kopiert wird (S)',
  'The next tap or click sets where to copy from (or Alt+click)':
    'Das nächste Tippen oder Klicken legt fest, wovon kopiert wird (oder Alt+Klick)',
  'On: the source moves along with the brush from stroke to stroke. Off: every stroke starts copying from the source':
    'An: die Quelle wandert von Strich zu Strich mit dem Pinsel. Aus: jeder Strich kopiert wieder ab der Quelle',
  'Clone tool in the raster app (S): paint with a copy of another part of the image. Tap (or Alt+click) where to copy from, paint the copy, drag the source disc with a finger to move it; aligned or not, with the brush’s size, tip, opacity and pen pressure.':
    'Klon-Werkzeug in der Raster-App (S): mit einer Kopie eines anderen Bildteils malen. Tippen (oder Alt+Klick), wovon kopiert wird, die Kopie malen, die Quellscheibe mit dem Finger verschieben; ausgerichtet oder nicht, mit Größe, Spitze, Deckkraft und Stiftdruck des Pinsels.',
  'Adjust colors':
    'Farben anpassen',
  'Stretch the picture’s tones to the full range':
    'Die Tonwerte des Bildes auf den vollen Umfang strecken',
  'Auto':
    'Automatisch',
  'Reset':
    'Zurücksetzen',
  'Hold to see the picture as it was':
    'Gedrückt halten, um das Bild wie vorher zu sehen',
  'Colors adjusted.':
    'Farben angepasst.',
  'Heal':
    'Reparieren',
  'Adjust colors…':
    'Farben anpassen…',
  'Select, Brush, Pencil, Eraser, Clone, Heal, Line, Polygon, Ellipse, Curve, Bucket, Pick color, Pan':
    'Auswahl, Pinsel, Stift, Radierer, Klonen, Reparieren, Linie, Polygon, Ellipse, Kurve, Farbeimer, Farbe aufnehmen, Verschieben',
  'Heal – like Clone, but the copy takes the color and light of the place you paint: for blemishes, spots and scratches (J)':
    'Reparieren – wie Klonen, aber die Kopie übernimmt Farbe und Licht der Stelle, an der du malst: für Makel, Flecken und Kratzer (J)',
  'Brightness, contrast, saturation, levels, sharpening and noise smoothing – for the selection or the whole image':
    'Helligkeit, Kontrast, Sättigung, Tonwerte, Schärfen und Rauschglättung – für die Auswahl oder das ganze Bild',
  'Photo fixes in the raster app: Adjust colors… – brightness, contrast, saturation, levels with Auto, sharpening and noise smoothing, previewed live (hold Before to compare).':
    'Fotokorrekturen in der Raster-App: Farben anpassen… – Helligkeit, Kontrast, Sättigung, Tonwerte mit Automatisch, Schärfen und Rauschglättung, mit Live-Vorschau (Vorher gedrückt halten zum Vergleichen).',
  'Heal brush (J): paints over blemishes, spots and scratches with texture from elsewhere, in the color and light of the spot.':
    'Reparatur-Pinsel (J): übermalt Makel, Flecken und Kratzer mit Struktur von anderswo, in Farbe und Licht der Stelle.',
  'Filling from the surroundings…':
    'Wird aus der Umgebung gefüllt…',
  'Removed.':
    'Entfernt.',
  'Could not fill it: {why}':
    'Füllen nicht möglich: {why}',
  'Select what to remove first.':
    'Wähle zuerst aus, was entfernt werden soll.',
  'Select':
    'Auswahl',
  'Rectangle':
    'Rechteck',
  'Lasso':
    'Lasso',
  'Magnetic':
    'Magnetisch',
  'Wand':
    'Zauberstab',
  'Add':
    'Hinzufügen',
  'Subtract':
    'Abziehen',
  'Drag inside the selection to move it. Copy, Clear, Fill from surroundings and Adjust colors follow its shape.':
    'Innerhalb der Auswahl ziehen, um sie zu verschieben. Kopieren, Löschen, Aus der Umgebung füllen und Farben anpassen folgen ihrer Form.',
  'Paint over what should disappear; when you lift, it is filled from the picture around it. Works best on backgrounds – grass, sky, walls, skin.':
    'Übermale, was verschwinden soll; beim Loslassen wird es aus dem umgebenden Bild gefüllt. Am besten auf Hintergründen – Gras, Himmel, Wände, Haut.',
  'Fill with':
    'Füllen mit',
  'Surroundings (built in)':
    'Umgebung (eingebaut)',
  'AI (add-on)':
    'KI (Add-on)',
  'Fill from surroundings':
    'Aus der Umgebung füllen',
  'Select, Brush, Pencil, Eraser, Clone, Heal, Remove, Line, Polygon, Ellipse, Curve, Bucket, Pick color, Pan':
    'Auswahl, Pinsel, Stift, Radierer, Klonen, Reparieren, Entfernen, Linie, Polygon, Ellipse, Kurve, Farbeimer, Farbe aufnehmen, Verschieben',
  'Shift / Alt + select':
    'Umschalt / Alt + Auswahl',
  'Add to / take away from the selection':
    'Zur Auswahl hinzufügen / von ihr abziehen',
  'Remove – paint over something to make it disappear: it is filled from the picture around it (R)':
    'Entfernen – übermale etwas, damit es verschwindet: es wird aus dem umgebenden Bild gefüllt (R)',
  'Shape':
    'Form',
  'A rectangle: drag across':
    'Ein Rechteck: darüber ziehen',
  'Freehand: draw around it':
    'Freihand: drumherum zeichnen',
  'Draw roughly along an edge – the line snaps to it':
    'Grob an einer Kante entlang zeichnen – die Linie rastet daran ein',
  'Tap a color: everything similar next to it (or anywhere)':
    'Auf eine Farbe tippen: alles Ähnliche daneben (oder überall)',
  'New selection':
    'Neue Auswahl',
  'Replace the selection':
    'Die Auswahl ersetzen',
  'Add to the selection (or hold Shift)':
    'Zur Auswahl hinzufügen (oder Umschalt halten)',
  'Take away from the selection (or hold Alt)':
    'Von der Auswahl abziehen (oder Alt halten)',
  'The selected part disappears: filled from the picture around it':
    'Der ausgewählte Teil verschwindet: aus dem umgebenden Bild gefüllt',
  'Shaped selections: Lasso, Magnetic (snaps to edges) and Wand (by color), with New / Add / Subtract (or Shift / Alt) – copy, clear, move and Adjust colors follow the shape.':
    'Auswahlen jeder Form: Lasso, Magnetisch (rastet an Kanten ein) und Zauberstab (nach Farbe), mit Neu / Hinzufügen / Abziehen (oder Umschalt / Alt) – Kopieren, Löschen, Verschieben und Farben anpassen folgen der Form.',
  'Removing things: the Remove brush (R) and Fill from surroundings for a selection fill the spot with the picture around it – content-aware, on the device.':
    'Dinge entfernen: der Entfernen-Pinsel (R) und Aus der Umgebung füllen für eine Auswahl füllen die Stelle mit dem umgebenden Bild – inhaltsbasiert, auf dem Gerät.',
  'Text':
    'Text',
  'Type here':
    'Hier tippen',
  'Font':
    'Schrift',
  'List the fonts installed on this computer (the browser asks first)':
    'Die auf diesem Computer installierten Schriften auflisten (der Browser fragt zuerst)',
  'More fonts…':
    'Weitere Schriften…',
  'Style':
    'Stil',
  'Bold':
    'Fett',
  'Italic':
    'Kursiv',
  'Alignment':
    'Ausrichtung',
  'Left':
    'Links',
  'Center':
    'Mittig',
  'Right':
    'Rechts',
  'Shadow':
    'Schatten',
  'The text is in the paint color, its outline in the outline color. Drag it into place, then press Enter or tap outside it.':
    'Der Text hat die Malfarbe, sein Umriss die Umrissfarbe. Ziehe ihn an seinen Platz und drücke dann Enter oder tippe daneben.',
  '{n} fonts listed.':
    '{n} Schriften aufgelistet.',
  'The browser did not list the fonts.':
    'Der Browser hat die Schriften nicht aufgelistet.',
  'Drag the text into place, then press Enter or tap outside it.':
    'Ziehe den Text an seinen Platz und drücke dann Enter oder tippe daneben.',
  'Tap where to copy from (or Alt+click), then paint the copy · drag the source disc to move it':
    'Tippe, wovon kopiert wird (oder Alt+Klick), dann male die Kopie · die Quellscheibe lässt sich ziehen',
  'Tap where to copy from (or Alt+click), then paint over the spot – it blends in when you lift':
    'Tippe, wovon kopiert wird (oder Alt+Klick), dann übermale die Stelle – beim Loslassen fügt sie sich ein',
  'Paint over what should disappear – it is filled from the surroundings when you lift':
    'Übermale, was verschwinden soll – beim Loslassen wird es aus der Umgebung gefüllt',
  'Tap to add text · drag it into place · tap it to edit · Enter places it':
    'Tippen fügt Text hinzu · an seinen Platz ziehen · antippen zum Bearbeiten · Enter setzt ihn',
  'Select, Brush, Pencil, Eraser, Clone, Heal, Remove, Blur, Noise, Twist, Text, Line, Polygon, Ellipse, Curve, Bucket, Pick color, Pan':
    'Auswahl, Pinsel, Stift, Radierer, Klonen, Reparieren, Entfernen, Weichzeichnen, Rauschen, Verdrehen, Text, Linie, Polygon, Ellipse, Kurve, Farbeimer, Farbe aufnehmen, Verschieben',
  'Text – tap to type; fonts, outline, shadow and curved text (T)':
    'Text – tippen und schreiben; Schriften, Umriss, Schatten und gebogener Text (T)',
  'Text tool in the raster app (T): any font (also the installed ones, where the browser lists them), size, bold, italic, alignment, outline, shadow and curved text. It floats until placed – drag it, tap it to edit.':
    'Text-Werkzeug in der Raster-App (T): jede Schrift (auch die installierten, wo der Browser sie auflistet), Größe, fett, kursiv, Ausrichtung, Umriss, Schatten und gebogener Text. Er schwebt, bis er gesetzt wird – ziehen, antippen zum Bearbeiten.',
  'The AI could not start in this browser.':
    'Die KI konnte in diesem Browser nicht starten.',
  'Starting the AI…':
    'KI wird gestartet…',
  'The AI could not do it: {why}':
    'Die KI konnte es nicht: {why}',
  'Looking at the picture…':
    'Das Bild wird angesehen…',
  'Nothing found there – tap the middle of the object.':
    'Dort wurde nichts gefunden – tippe in die Mitte des Objekts.',
  'the AI add-on is not downloaded':
    'das KI-Add-on ist nicht heruntergeladen',
  'Remove background':
    'Hintergrund entfernen',
  'What is in the picture?':
    'Was ist auf dem Bild?',
  'People (portraits)':
    'Menschen (Porträts)',
  'Any subject (objects, animals, products)':
    'Beliebiges Motiv (Gegenstände, Tiere, Produkte)',
  'Each needs a one-time download – the size is shown before anything is downloaded. Everything runs on this device.':
    'Jedes braucht einen einmaligen Download – die Größe wird angezeigt, bevor etwas heruntergeladen wird. Alles läuft auf diesem Gerät.',
  'Select the subject':
    'Das Motiv auswählen',
  'Finding the subject…':
    'Das Motiv wird gesucht…',
  'The subject is selected.':
    'Das Motiv ist ausgewählt.',
  'Background removed.':
    'Hintergrund entfernt.',
  'Could not load the text recognition.':
    'Die Texterkennung konnte nicht geladen werden.',
  'Reading the text…':
    'Der Text wird gelesen…',
  'Text in the picture':
    'Text im Bild',
  'You can correct it here before copying.':
    'Du kannst ihn hier vor dem Kopieren korrigieren.',
  'Copied.':
    'Kopiert.',
  'Select the text and copy it (Ctrl+C).':
    'Markiere den Text und kopiere ihn (Strg+C).',
  'No text found.':
    'Kein Text gefunden.',
  '3D relief':
    '3D-Relief',
  'A 3D-printable relief of the picture (STL): from its brightness, or from the depth an AI sees in a photo.':
    'Ein 3D-druckbares Relief des Bildes (STL): aus seiner Helligkeit oder aus der Tiefe, die eine KI in einem Foto sieht.',
  'Brightness – light is high':
    'Helligkeit – hell ist hoch',
  'Brightness – dark is high (a lithophane: hold it against light)':
    'Helligkeit – dunkel ist hoch (eine Lithophanie: gegen das Licht halten)',
  'Depth (AI add-on) – near is high':
    'Tiefe (KI-Add-on) – nah ist hoch',
  'Relief':
    'Relief',
  'Low':
    'Niedrig',
  'Medium':
    'Mittel',
  'High':
    'Hoch',
  'Smoothing':
    'Glättung',
  'Height map: white is high':
    'Höhenkarte: weiß ist hoch',
  'Save STL':
    'STL speichern',
  'Working out the depth…':
    'Die Tiefe wird ermittelt…',
  '{w} × {h} mm, {z} mm high':
    '{w} × {h} mm, {z} mm hoch',
  'Saved relief.stl.':
    'relief.stl gespeichert.',
  'Select object (AI)':
    'Objekt auswählen (KI)',
  'Tap an object to select it.':
    'Ein Objekt antippen, um es auszuwählen.',
  'Object removal (AI)':
    'Objekte entfernen (KI)',
  'Remove fills the spot with a trained model – better on objects and structure than the built-in fill.':
    'Entfernen füllt die Stelle mit einem trainierten Modell – besser bei Objekten und Strukturen als die eingebaute Füllung.',
  'Background removal – people':
    'Hintergrund entfernen – Menschen',
  'Removes the background behind people (portraits).':
    'Entfernt den Hintergrund hinter Menschen (Porträts).',
  'Background removal – any subject':
    'Hintergrund entfernen – beliebiges Motiv',
  'Removes the background behind the main subject: objects, animals, products.':
    'Entfernt den Hintergrund hinter dem Hauptmotiv: Gegenstände, Tiere, Produkte.',
  'Read text (OCR)':
    'Text lesen (OCR)',
  'Recognizes text in the image, to copy it.':
    'Erkennt Text im Bild, um ihn zu kopieren.',
  'Depth for 3D relief (AI)':
    'Tiefe für 3D-Relief (KI)',
  'Estimates the depth of a photo for a 3D-printable relief.':
    'Schätzt die Tiefe eines Fotos für ein 3D-druckbares Relief.',
  'Download failed ({status}).':
    'Download fehlgeschlagen ({status}).',
  'This needs a one-time download of {size}.':
    'Dafür ist ein einmaliger Download von {size} nötig.',
  'That includes the AI engine ({size}), shared by all AI add-ons.':
    'Das enthält die KI-Engine ({size}), die alle KI-Add-ons teilen.',
  'It is kept in this browser and works offline afterwards; the Add-ons list in the side panel removes it again. Everything runs on this device – your pictures are not uploaded.':
    'Es bleibt in diesem Browser und funktioniert danach auch offline; die Add-on-Liste in der Seitenleiste entfernt es wieder. Alles läuft auf diesem Gerät – deine Bilder werden nicht hochgeladen.',
  'Download {size}':
    '{size} herunterladen',
  'Downloading…':
    'Wird heruntergeladen…',
  '{name} is ready.':
    '{name} ist bereit.',
  'Could not download it: {why}':
    'Download nicht möglich: {why}',
  'installed':
    'installiert',
  'Download':
    'Herunterladen',
  'Used by add-ons: {size}. Sizes include the shared AI engine where it is not downloaded yet.':
    'Von Add-ons belegt: {size}. Die Größen enthalten die gemeinsame KI-Engine, solange sie nicht heruntergeladen ist.',
  'Removed the add-on.':
    'Add-on entfernt.',
  'Object (AI)':
    'Objekt (KI)',
  'Remove background…':
    'Hintergrund entfernen…',
  'Read text…':
    'Text lesen…',
  '3D relief…':
    '3D-Relief…',
  'Add-ons':
    'Add-ons',
  'Features that need a one-time download. Nothing is downloaded until you agree; everything runs on this device.':
    'Funktionen, die einen einmaligen Download brauchen. Nichts wird heruntergeladen, bevor du zustimmst; alles läuft auf diesem Gerät.',
  'Tap an object: the AI selects it (an add-on – asks before downloading)':
    'Ein Objekt antippen: die KI wählt es aus (ein Add-on – fragt vor dem Download)',
  'Make the background transparent, or select the subject (an AI add-on – asks before downloading)':
    'Den Hintergrund transparent machen oder das Motiv auswählen (ein KI-Add-on – fragt vor dem Download)',
  'Recognize the text in the image or the selection, to copy it (an add-on – asks before downloading)':
    'Den Text im Bild oder in der Auswahl erkennen, um ihn zu kopieren (ein Add-on – fragt vor dem Download)',
  'A 3D-printable relief (STL) from the picture\'s brightness, or from AI depth':
    'Ein 3D-druckbares Relief (STL) aus der Helligkeit des Bildes oder aus KI-Tiefe',
  'Add-ons that run on your device, each downloaded only after you agree to its size: Select object (tap it), AI object removal, background removal, Read text (OCR) and depth for 3D reliefs. The side panel lists them and removes them again.':
    'Add-ons, die auf deinem Gerät laufen und erst nach Zustimmung zu ihrer Größe heruntergeladen werden: Objekt auswählen (antippen), KI-Objektentfernung, Hintergrund entfernen, Text lesen (OCR) und Tiefe für 3D-Reliefs. Die Seitenleiste listet sie auf und entfernt sie wieder.',
  '3D relief…: a printable relief (STL) from the picture\'s brightness – or a lithophane – or from AI depth.':
    '3D-Relief…: ein druckbares Relief (STL) aus der Helligkeit des Bildes – oder eine Lithophanie – oder aus KI-Tiefe.',
  'Layer {n}':
    'Ebene {n}',
  'Saved as one picture – Save layers (.ora) in the Layers section keeps the layers.':
    'Als ein Bild gespeichert – Ebenen speichern (.ora) im Bereich Ebenen behält die Ebenen.',
  'The last layer can’t be deleted.':
    'Die letzte Ebene kann nicht gelöscht werden.',
  'There is no layer under this one.':
    'Unter dieser Ebene liegt keine.',
  'Name of the layer:':
    'Name der Ebene:',
  'Hide this layer':
    'Diese Ebene ausblenden',
  'Show this layer':
    'Diese Ebene einblenden',
  'Show {name}':
    '{name} anzeigen',
  'Saved {name} with {n} {n|layer|layers}.':
    '{name} mit {n} {n|Ebene|Ebenen} gespeichert.',
  'Opened {name} ({n} {n|layer|layers}).':
    '{name} geöffnet ({n} {n|Ebene|Ebenen}).',
  'Could not read this OpenRaster file.':
    'Diese OpenRaster-Datei konnte nicht gelesen werden.',
  'Merge down':
    'Nach unten zusammenfügen',
  'Flatten':
    'Auf eine Ebene reduzieren',
  'Save layers (.ora)':
    'Ebenen speichern (.ora)',
  'Painting and the other tools work on the active layer. Tap a layer to make it active, double-click to rename. Save keeps the picture as it looks; Save layers keeps the layers.':
    'Malen und die anderen Werkzeuge wirken auf die aktive Ebene. Tippe eine Ebene an, um sie zu aktivieren, Doppelklick benennt sie um. Speichern sichert das Bild, wie es aussieht; Ebenen speichern behält die Ebenen.',
  'Layers (.ora)':
    'Ebenen (.ora)',
  'Layers – the top one first':
    'Ebenen – die oberste zuerst',
  'A new, empty layer above this one':
    'Eine neue, leere Ebene über dieser',
  'A copy of this layer':
    'Eine Kopie dieser Ebene',
  'Move this layer up':
    'Diese Ebene nach oben',
  'Move up':
    'Nach oben',
  'Move this layer down':
    'Diese Ebene nach unten',
  'Move down':
    'Nach unten',
  'Delete this layer':
    'Diese Ebene löschen',
  'Put this layer onto the one under it':
    'Diese Ebene auf die darunter legen',
  'All the layers as one':
    'Alle Ebenen zu einer',
  'Save every layer in one file (OpenRaster – GIMP, Krita and others open it); Open… opens it again':
    'Alle Ebenen in einer Datei speichern (OpenRaster – GIMP, Krita und andere öffnen sie); Öffnen… öffnet sie wieder',
  'Layers in the raster app: paint on the active layer, show / hide, opacity, move, merge, flatten – undo knows them all. Save layers keeps them in an OpenRaster file (.ora – GIMP and Krita open it), and autosave keeps them too.':
    'Ebenen in der Raster-App: auf die aktive Ebene malen, ein- / ausblenden, Deckkraft, verschieben, zusammenfügen, reduzieren – Rückgängig kennt alles. Ebenen speichern behält sie in einer OpenRaster-Datei (.ora – GIMP und Krita öffnen sie), und das automatische Speichern auch.',
  'The AI add-ons on phones: much less memory (no more crash on iPhone when selecting an object) – the CPU engine on iPhone and iPad, and one feature\'s models at a time.':
    'Die KI-Add-ons auf Handys: viel weniger Speicher (kein Absturz mehr beim Auswählen eines Objekts auf dem iPhone) – auf iPhone und iPad die CPU-Engine, und immer nur die Modelle einer Funktion.',
  'Frame {n} of {count}':
    'Bild {n} von {count}',
  '{s} s of {total} s':
    '{s} s von {total} s',
  'Choose a frame':
    'Bild auswählen',
  'One frame back':
    'Ein Bild zurück',
  'Play / pause':
    'Abspielen / Pause',
  'One frame on':
    'Ein Bild weiter',
  'Use this frame':
    'Dieses Bild verwenden',
  'This video can’t be played here – try a GIF or a screenshot of it.':
    'Dieses Video lässt sich hier nicht abspielen – versuche ein GIF oder einen Screenshot davon.',
  'GIFs and videos: open one (or, in Discord, a GIF, a video or a Tenor / Giphy GIF from the chat) and choose the frame to edit – with a slider, frame steps and play.':
    'GIFs und Videos: öffne eines (in Discord auch ein GIF, ein Video oder ein Tenor- / Giphy-GIF aus dem Chat) und wähle das Bild zum Bearbeiten – mit Schieberegler, Einzelbildschritten und Abspielen.',
  'Everything was selected – now nothing is.':
    'Alles war ausgewählt – jetzt nichts mehr.',
  'Invert':
    'Umkehren',
  'Select the other shapes instead (Ctrl+I)':
    'Stattdessen die anderen Formen auswählen (Strg+I)',
  'Adjust':
    'Anpassen',
  'Invert selection':
    'Auswahl umkehren',
  'Invert the selection':
    'Die Auswahl umkehren',
  'Brightness, contrast, warmth and the other photo sliders – for the selection or the whole image':
    'Helligkeit, Kontrast, Wärme und die anderen Foto-Regler – für die Auswahl oder das ganze Bild',
  'Select what isn\'t selected (Ctrl+I)':
    'Auswählen, was nicht ausgewählt ist (Strg+I)',
  'Light':
    'Licht',
  'Detail and effects':
    'Details und Effekte',
  'Levels':
    'Tonwerte',
  'Vibrance':
    'Dynamik',
  'Warmth':
    'Wärme',
  'Tint':
    'Farbton',
  'Fade':
    'Verblassen',
  'Vignette':
    'Vignette',
  'Black point':
    'Schwarzpunkt',
  'White point':
    'Weißpunkt',
  'Shadows':
    'Tiefen',
  'Highlights':
    'Lichter',
  'Midtones':
    'Mitteltöne',
  'Nicer icons for undo / redo, zoom, fit and help; Adjust is in the toolbar and the quick menu, with new sliders – shadows, highlights, warmth, tint, vibrance, fade and vignette. Invert selection (Ctrl+I) in both apps.':
    'Schönere Symbole für Rückgängig / Wiederholen, Zoom, Einpassen und Hilfe; Anpassen in der Leiste und im Schnellmenü, mit neuen Reglern – Tiefen, Lichter, Wärme, Farbton, Dynamik, Verblassen und Vignette. Auswahl umkehren (Strg+I) in beiden Apps.',
  'Select object (AI) no longer crashes on phones: it now uses MobileSAM, which needs a quarter of the memory (and is faster). Its download is larger (45 MB); the old model is removed.':
    'Objekt auswählen (KI) stürzt auf Handys nicht mehr ab: es nutzt jetzt MobileSAM, das ein Viertel des Speichers braucht (und schneller ist). Der Download ist größer (45 MB); das alte Modell wird entfernt.',
  'Import a picture':
    'Ein Bild importieren',
  'Put a picture from a file into this image – drag it into place, then press Enter (or tap outside it)':
    'Ein Bild aus einer Datei in dieses Bild setzen – an seinen Platz ziehen, dann Enter drücken (oder daneben tippen)',
  'Import… puts a picture from a file into the current image (also in the quick menu): it comes in floating, scaled to fit – drag it into place.':
    'Importieren… setzt ein Bild aus einer Datei ins aktuelle Bild (auch im Schnellmenü): es kommt schwebend, passend verkleinert – an seinen Platz ziehen.',
  'Two fingers on a selection':
    'Zwei Finger auf einer Auswahl',
  'Scale, turn and move it (spread, pinch, twist)':
    'Skalieren, drehen und verschieben (spreizen, zusammenziehen, drehen)',
  'Two fingers on a selection (or a pasted, imported picture or text) scale and turn it: spread or pinch, twist – and move it. It snaps upright and to its own size, and is always made from the original pixels, so it doesn’t blur. Elsewhere two fingers zoom the view as before.':
    'Zwei Finger auf einer Auswahl (oder einem eingefügten, importierten Bild oder Text) skalieren und drehen sie: spreizen oder zusammenziehen, drehen – und verschieben. Sie rastet aufrecht und bei der Originalgröße ein und entsteht immer aus den ursprünglichen Pixeln, wird also nicht unscharf. Anderswo zoomen zwei Finger die Ansicht wie bisher.',
  'On phones, the Select shapes (and other rows of choices) wrap onto a second line instead of cutting off the last one – Object (AI) can be tapped again.':
    'Auf Handys brechen die Auswahlformen (und andere Auswahlreihen) in eine zweite Zeile um, statt die letzte abzuschneiden – Objekt (KI) lässt sich wieder antippen.',
  'Drag a corner of the selection':
    'Eine Ecke der Auswahl ziehen',
  'Scale it (the opposite corner stays)':
    'Skalieren (die gegenüberliegende Ecke bleibt)',
  'Scale a selection with the mouse: drag one of the handles in its corners – the opposite corner stays put and the proportions are kept. As with two fingers, it is always made from the original pixels.':
    'Eine Auswahl mit der Maus skalieren: an einem der Griffe in ihren Ecken ziehen – die gegenüberliegende Ecke bleibt, die Proportionen bleiben erhalten. Wie mit zwei Fingern entsteht sie immer aus den ursprünglichen Pixeln.',
  'Paint to soften – edges of pasted photos blend in · [ ] size · a soft tip blends best':
    'Malen zum Weichzeichnen – Ränder eingefügter Fotos verschmelzen · [ ] Größe · eine weiche Spitze verschmilzt am besten',
  'Paint to add grain – a smooth patch matches the photo around it · [ ] size':
    'Malen fügt Körnung hinzu – eine glatte Stelle passt zum Foto ringsum · [ ] Größe',
  'Blur':
    'Weichzeichnen',
  'Noise':
    'Rauschen',
  'Strength':
    'Stärke',
  'Amount':
    'Menge',
  'Colored grain':
    'Farbige Körnung',
  'To blend a photo in: blur along its edge, then add a little grain so it matches the picture around it. Each stroke adds more; the tip and opacity are the brush\'s.':
    'Ein Foto einblenden: am Rand weichzeichnen, dann etwas Körnung hinzufügen, damit es zum Bild ringsum passt. Jeder Strich verstärkt es; Spitze und Deckkraft sind die des Pinsels.',
  'Blur – paint to soften: blends the edges of a pasted photo into the picture (U)':
    'Weichzeichnen – malen zum Weichzeichnen: lässt die Ränder eines eingefügten Fotos ins Bild übergehen (U)',
  'Noise – paint to add grain: makes a smooth or pasted part match a photo\'s texture (N)':
    'Rauschen – malen fügt Körnung hinzu: ein glatter oder eingefügter Teil bekommt die Struktur des Fotos (N)',
  'How soft: about this many pixels':
    'Wie weich: etwa so viele Pixel',
  'How much grain':
    'Wie viel Körnung',
  'Off: the same grain in red, green and blue (like film). On: each its own':
    'Aus: dieselbe Körnung in Rot, Grün und Blau (wie Film). An: jede Farbe ihre eigene',
  'Blur (U) and Noise (N) brushes, to blend photos into each other: blur along the edge of a pasted photo to soften it (a cut-out’s edge fades out), then add a little grain so it matches the picture around it.':
    'Pinsel Weichzeichnen (U) und Rauschen (N), um Fotos ineinander übergehen zu lassen: den Rand eines eingefügten Fotos weichzeichnen (der Rand eines Ausschnitts blendet aus), dann etwas Körnung hinzufügen, damit es zum Bild ringsum passt.',
  'In a narrower window the top bar scrolls on its own instead of pushing the whole page sideways (the canvas could slide out of view).':
    'In einem schmaleren Fenster scrollt die obere Leiste für sich, statt die ganze Seite zur Seite zu schieben (die Leinwand konnte aus dem Blick rutschen).',
  'Compress video…':
    'Video verkleinern…',
  'Make a video small enough for Discord – on your device – and post it here':
    'Ein Video klein genug für Discord machen – auf deinem Gerät – und hier posten',
  'Compress a video':
    'Ein Video verkleinern',
  'The video is made smaller on your device, then posted to the channel.':
    'Das Video wird auf deinem Gerät verkleinert und dann im Kanal gepostet.',
  'Choose a video…':
    'Video auswählen…',
  'Small enough already – it is posted as it is.':
    'Schon klein genug – es wird so gepostet, wie es ist.',
  'Use as it is':
    'So verwenden',
  'Compress':
    'Verkleinern',
  'Too long for {size} MB – the picture would be very poor. Choose the larger size or a shorter video.':
    'Zu lang für {size} MB – das Bild wäre sehr schlecht. Wähle die größere Größe oder ein kürzeres Video.',
  '→ about {w} × {h}, {rate} Mbit/s':
    '→ etwa {w} × {h}, {rate} Mbit/s',
  'Opening {name}…':
    '{name} wird geöffnet…',
  'This video can’t be read here – try another one (MP4, MOV or WebM).':
    'Dieses Video lässt sich hier nicht lesen – versuche ein anderes (MP4, MOV oder WebM).',
  'Could not compress the video.':
    'Das Video konnte nicht verkleinert werden.',
  '{size} (was {before})':
    '{size} (vorher {before})',
  'without sound (this browser can’t make it)':
    'ohne Ton (dieser Browser kann ihn nicht erzeugen)',
  'still too big – choose the larger size or a shorter video':
    'immer noch zu groß – wähle die größere Größe oder ein kürzeres Video',
  'Discord did not take a video this big – try 10 MB.':
    'Discord hat ein so großes Video nicht angenommen – versuche 10 MB.',
  'Use “Compress video” on a message or /compress-video in this chat to post here.':
    'Nutze „Compress video“ an einer Nachricht oder /compress-video in diesem Chat, um hier zu posten.',
  'More than 15 minutes have passed, and Discord no longer lets the app post. Run /compress-video again.':
    'Mehr als 15 Minuten sind vergangen, und Discord lässt die App nicht mehr posten. Starte /compress-video erneut.',
  'Discord did not take the video.':
    'Discord hat das Video nicht angenommen.',
  'Choose a video from your device.':
    'Wähle ein Video von deinem Gerät.',
  'Discord: compress a video to fit Discord’s limit and post it – right-click a message with a video › Apps › Compress video, or /compress-video for a video from your device. It is made smaller on your device (20 MB or 10 MB), shown, then posted.':
    'Discord: ein Video für Discords Größengrenze verkleinern und posten – Rechtsklick auf eine Nachricht mit Video › Apps › Compress video, oder /compress-video für ein Video von deinem Gerät. Es wird auf deinem Gerät verkleinert (20 MB oder 10 MB), gezeigt und dann gepostet.',
  'Turn left 90°':
    '90° nach links drehen',
  'Turn right 90°':
    '90° nach rechts drehen',
  'Flip horizontally':
    'Horizontal spiegeln',
  'Flip vertically':
    'Vertikal spiegeln',
  'Duplicate – leave a copy here and move this one on':
    'Duplizieren – eine Kopie bleibt hier, diese wandert weiter',
  'Delete the selected pixels (Del)':
    'Die ausgewählten Pixel löschen (Entf)',
  'Drag the knob above a selection':
    'Den Griff über einer Auswahl ziehen',
  'Turn it (Shift: 15° steps)':
    'Drehen (Shift: 15°-Schritte)',
  'A selection now has a knob above it to turn it (it snaps upright; Shift: 15° steps) and a bar below it: turn left / right, flip horizontally / vertically, duplicate, delete, cancel, place – with the mouse or a finger.':
    'Eine Auswahl hat jetzt einen Griff darüber zum Drehen (rastet aufrecht ein; Shift: 15°-Schritte) und eine Leiste darunter: links / rechts drehen, horizontal / vertikal spiegeln, duplizieren, löschen, abbrechen, platzieren – mit der Maus oder dem Finger.',
  'Press at the centre, drag out for the size, then go round it to twist – the further round, the stronger · lift to finish':
    'In der Mitte drücken, für die Größe nach außen ziehen, dann herumfahren zum Verdrehen – je weiter herum, desto stärker · Loslassen beendet',
  'Twist':
    'Verdrehen',
  'Press where the swirl\'s centre should be and drag out: the circle shows how far it reaches. Then go round the centre – the further round, the stronger the twist (back the other way to undo it). Lift to finish; with a selection, only the selected pixels twist.':
    'Dort drücken, wo die Mitte des Wirbels sein soll, und nach außen ziehen: Der Kreis zeigt, wie weit er reicht. Dann um die Mitte herumfahren – je weiter herum, desto stärker die Verdrehung (zurück macht sie rückgängig). Loslassen beendet; mit einer Auswahl verdrehen sich nur die ausgewählten Pixel.',
  'Twist – press, drag out for the size, go round to swirl the picture (W)':
    'Verdrehen – drücken, für die Größe nach außen ziehen, herumfahren, und das Bild wirbelt (W)',
  'Twist tool (W): press where the swirl’s centre should be, drag out for its size, then go round – the further round, the stronger the twist (either way). With a selection, only the selected pixels twist.':
    'Werkzeug Verdrehen (W): dort drücken, wo die Mitte des Wirbels sein soll, für seine Größe nach außen ziehen, dann herumfahren – je weiter herum, desto stärker die Verdrehung (in beide Richtungen). Mit einer Auswahl verdrehen sich nur die ausgewählten Pixel.',
  'Click a line or shape to pick it, then drag it – or press Delete':
    'Klick auf eine Linie oder Form, um sie auszuwählen, dann zieh sie – oder drück Entf',
  'Drag to draw a line – it sticks to the lines and corners already there':
    'Zieh, um eine Linie zu zeichnen – sie haftet an den Linien und Ecken, die schon da sind',
  'Drag from the middle to draw a shape – pick how many corners on the right':
    'Zieh von der Mitte aus, um eine Form zu zeichnen – rechts wählst du, wie viele Ecken',
  'Drag to draw a circle or an oval':
    'Zieh, um einen Kreis oder ein Oval zu zeichnen',
  'Click inside an area to fill it with tiles':
    'Klick in eine Fläche, um sie mit Fliesen zu füllen',
  'Pick a color, then click a tile to paint it – or drag across many tiles':
    'Wähl eine Farbe, dann klick auf eine Fliese, um sie anzumalen – oder zieh über viele Fliesen',
  'Make a mosaic: draw the lines between the tiles, or fill an area with tiles, then paint each tile.':
    'Mach ein Mosaik: Zeichne die Linien zwischen den Fliesen oder füll eine Fläche mit Fliesen, dann mal jede Fliese an.',
  'Pick a tool on the left: Line, Shapes and Circles draw, Tiles fills an area with tiles, Paint colors a tile when you click it.':
    'Wähl links ein Werkzeug: Linie, Formen und Kreise zeichnen, Fliesen füllt eine Fläche mit Fliesen, Malen färbt die Fliese, die du anklickst.',
  'Click a color, then click the tiles with Paint. Made a mistake? The arrow at the top takes it back.':
    'Klick auf eine Farbe, dann mit Malen auf die Fliesen. Vertan? Der Pfeil oben macht es rückgängig.',
  'Shapes':
    'Formen',
  'Circles':
    'Kreise',
  'Small tiles':
    'Kleine Fliesen',
  'Big':
    'Groß',
  'Simple: only the drawing tools and the colors – for children and quick mosaics. Expert: everything':
    'Einfach: nur die Zeichenwerkzeuge und die Farben – für Kinder und schnelle Mosaike. Experte: alles',
  'Tile size':
    'Fliesengröße',
  'The vector app’s Simple mode is now made for children: only the basic tools (with a word under each) – Select, Line, Shapes, Circles, Tiles, Paint – and big colors; on phones and tablets the colors are along the bottom too. Everything else is in Expert mode.':
    'Der einfache Modus der Vektor-App ist jetzt für Kinder gemacht: nur die Grundwerkzeuge (jedes mit einem Wort darunter) – Auswahl, Linie, Formen, Kreise, Fliesen, Malen – und große Farben; auf Handys und Tablets sind die Farben auch unten. Alles andere ist im Expertenmodus.',
  'Remove the picture?':
    'Das Bild entfernen?',
  'Picture loaded – draw over it.':
    'Bild geladen – zeichne darüber.',
  'Choose another picture…':
    'Anderes Bild wählen…',
  'Choose a picture…':
    'Bild wählen…',
  'Shards':
    'Scherben',
  'Hand-laid lines':
    'Von Hand gelegte Fugen',
  'Uneven, tapered lines – as if the shards were laid by hand':
    'Ungleiche, spitz zulaufende Fugen – als wären die Scherben von Hand gelegt',
  'Shuffle':
    'Mischen',
  'Unevenness':
    'Ungleichheit',
  'Picture to draw over':
    'Bild unter der Zeichnung',
  'Shards – uneven, tapered lines, as if the glass were laid by hand (click again: even lines)':
    'Scherben – ungleiche, spitz zulaufende Fugen, als wäre das Glas von Hand gelegt (nochmal: gleichmäßige Fugen)',
  'Other widths for every piece':
    'Andere Breiten für jedes Stück',
  'Simple mode: Choose a picture… puts a picture under the drawing to draw the tile shapes over (it can fade, or go).':
    'Einfacher Modus: Bild wählen… legt ein Bild unter die Zeichnung, über das du die Fliesenformen zeichnest (es kann blasser werden oder weg).',
  'Shards (both modes): uneven, tapered lines, as if glass shards were laid by hand – every piece between two crossings gets its own width, wider at one end. Shuffle for other widths; Unevenness in the panel. The lines stay as they are underneath; files and pictures keep the look.':
    'Scherben (beide Modi): ungleiche, spitz zulaufende Fugen, als wären Glasscherben von Hand gelegt – jedes Stück zwischen zwei Kreuzungen bekommt seine eigene Breite, an einem Ende breiter. Mischen gibt andere Breiten; Ungleichheit im Panel. Die Linien darunter bleiben, wie sie sind; Dateien und Bilder behalten das Aussehen.',
  'Off: every tile gets the one color you picked. Turn it on to give each tile one of these {n} colors at random.':
    'Aus: Jede Fliese bekommt die eine Farbe, die du gewählt hast. Schalte es ein, damit jede Fliese zufällig eine dieser {n} Farben bekommt.',
  'Mixing off – painting with one color. (Mix colors in the Paint options turns it on again.)':
    'Mischen aus – es wird mit einer Farbe gemalt. (Farben mischen in den Optionen von Malen schaltet es wieder ein.)',
  '＋ Add a color':
    '＋ Farbe hinzufügen',
  'Clear palette':
    'Palette leeren',
  'Choose any color and add it to the palette':
    'Eine beliebige Farbe wählen und zur Palette hinzufügen',
  'Remove all colors from the palette':
    'Alle Farben aus der Palette entfernen',
  'Picking one color (a swatch without Shift) switches the color mix off – the bucket paints with that color. The Mix colors switch shows in Simple mode too, and so do ＋ Add a color and Clear palette.':
    'Eine Farbe wählen (ein Farbfeld ohne Shift) schaltet das Farbmischen aus – der Farbeimer malt mit dieser Farbe. Der Schalter Farben mischen ist auch im einfachen Modus da, ebenso ＋ Farbe hinzufügen und Palette leeren.',
  'Set up the palette':
    'Palette einrichten',
  'Copy colors on any website – a palette site, color codes, a list – and paste them here (Ctrl+V). Every color found shows below; click one to leave it out.':
    'Kopiere Farben auf irgendeiner Website – einer Paletten-Seite, Farbcodes, eine Liste – und füge sie hier ein (Strg+V). Jede gefundene Farbe erscheint unten; klick eine an, um sie wegzulassen.',
  'Paste from clipboard':
    'Aus der Zwischenablage einfügen',
  'Colors to paste':
    'Einzufügende Farben',
  'Colors found':
    'Gefundene Farben',
  'Add to my palette':
    'Zu meiner Palette hinzufügen',
  'Use instead of my palette':
    'Statt meiner Palette verwenden',
  'Use these colors':
    'Diese Farben verwenden',
  '{n} {n|color|colors} found.':
    '{n} {n|Farbe|Farben} gefunden.',
  'No colors found in this text – copy the color codes (like #2a9d8f), not just the picture.':
    'In diesem Text sind keine Farben – kopiere die Farbcodes (wie #2a9d8f), nicht nur das Bild.',
  'This browser won’t let the page read the clipboard – click in the box and press Ctrl+V.':
    'Dieser Browser lässt die Seite die Zwischenablage nicht lesen – klick in das Feld und drück Strg+V.',
  'The palette now has {n} {n|color|colors}.':
    'Die Palette hat jetzt {n} {n|Farbe|Farben}.',
  'Added {n} {n|color|colors} to the palette.':
    '{n} {n|Farbe|Farben} zur Palette hinzugefügt.',
  'All these colors are in the palette already.':
    'Alle diese Farben sind schon in der Palette.',
  'Paste colors…':
    'Farben einfügen…',
  'Paste colors copied on another website':
    'Auf einer anderen Website kopierte Farben einfügen',
  'Visible – click to hide':
    'Sichtbar – klicken zum Ausblenden',
  'Hidden – click to show':
    'Ausgeblendet – klicken zum Einblenden',
  'Locked – click to unlock':
    'Gesperrt – klicken zum Entsperren',
  'Unlocked – click to lock':
    'Entsperrt – klicken zum Sperren',
  'Paste colors… sets up the palette from colors copied on another website – a palette site like Coolors, color codes, CSS: every color found shows, click one to leave it out, then add them or use them instead of the palette (both apps).':
    'Farben einfügen… richtet die Palette aus Farben ein, die auf einer anderen Website kopiert wurden – einer Paletten-Seite wie Coolors, Farbcodes, CSS: Jede gefundene Farbe erscheint, ein Klick lässt sie weg, dann fügst du sie hinzu oder nimmst sie statt der Palette (beide Apps).',
  'done':
    'fertig',
  '{n} of {m} tasks done':
    '{n} von {m} Aufgaben geschafft',
  'Next: {title}':
    'Weiter: {title}',
  'Look around':
    'Schau dich um',
  'A ladybird is hiding in the meadow. Zoom in and find it!':
    'Auf der Wiese versteckt sich ein Marienkäfer. Zoome hinein und finde ihn!',
  'Zoom in to see details, move around with the hand (or two fingers), and Fit shows the whole picture.':
    'Mit Zoomen siehst du Details, mit der Hand (oder zwei Fingern) bewegst du dich, und Einpassen zeigt das ganze Bild.',
  'Tap Zoom in to look closer.':
    'Tippe auf Vergrößern, um genauer hinzusehen.',
  'Spread two fingers on the picture to zoom in.':
    'Zieh zwei Finger auf dem Bild auseinander, um hineinzuzoomen.',
  'Tap the hand – it moves the picture.':
    'Tippe auf die Hand – sie verschiebt das Bild.',
  'Drag the picture until you find the ladybird.':
    'Zieh das Bild, bis du den Marienkäfer findest.',
  'You found it! Now tap Fit to see the whole picture again.':
    'Gefunden! Tippe jetzt auf Einpassen, um wieder das ganze Bild zu sehen.',
  'Night sky':
    'Nachthimmel',
  'The night sky needs glowing stars. Paint them with a soft brush.':
    'Der Nachthimmel braucht leuchtende Sterne. Mal sie mit einem weichen Pinsel.',
  'The Brush paints soft lines. Size makes it bigger, and the Soft tip makes it glow at the edges.':
    'Der Pinsel malt weiche Linien. Die Größe macht ihn größer, und die weiche Spitze lässt ihn an den Rändern leuchten.',
  'Tap the Brush.':
    'Tippe auf den Pinsel.',
  'Tap the yellow color.':
    'Tippe auf die gelbe Farbe.',
  'Choose the Soft tip – it glows at the edges.':
    'Wähl die weiche Spitze – sie leuchtet an den Rändern.',
  'Make the brush big: slide Size to 30 or more.':
    'Mach den Pinsel groß: Schieb die Größe auf 30 oder mehr.',
  'Paint over the 3 stars.':
    'Mal über die 3 Sterne.',
  'Fill the heart square by square – like a real mosaic.':
    'Füll das Herz Kästchen für Kästchen – wie ein echtes Mosaik.',
  'The Pencil paints whole squares in exactly the chosen color – just right for pixel art.':
    'Der Stift malt ganze Kästchen genau in der gewählten Farbe – genau richtig für Pixel-Art.',
  'Tap the Pencil.':
    'Tippe auf den Stift.',
  'Tap the red color.':
    'Tippe auf die rote Farbe.',
  'Make the pencil as small as it goes: slide Size all the way left.':
    'Mach den Stift so klein wie möglich: Schieb die Größe ganz nach links.',
  'Fill the inside of the heart, square by square.':
    'Füll das Innere des Herzens, Kästchen für Kästchen.',
  'Muddy window':
    'Schmutziges Fenster',
  'Someone threw mud at the window. Rub it off!':
    'Jemand hat Matsch ans Fenster geworfen. Radier ihn weg!',
  'The Eraser takes paint away – where it rubs, the picture becomes see-through (the checkerboard).':
    'Der Radierer nimmt Farbe weg – wo er reibt, wird das Bild durchsichtig (das Schachbrett).',
  'Tap the Eraser.':
    'Tippe auf den Radierer.',
  'Make it big: slide Size to 30 or more.':
    'Mach ihn groß: Schieb die Größe auf 30 oder mehr.',
  'Rub out the 4 mud spots.':
    'Radier die 4 Matschflecken weg.',
  'Copy the color':
    'Farbe kopieren',
  'The parrot lost a feather. Paint a new one in exactly the same purple.':
    'Der Papagei hat eine Feder verloren. Mal eine neue in genau demselben Lila.',
  'The color picker takes a color from the picture. (Tip: Alt+click does it with any brush.)':
    'Die Pipette nimmt eine Farbe aus dem Bild. (Tipp: Mit jedem Pinsel geht es mit Alt+Klick.)',
  'Tap the color picker – the dropper.':
    'Tippe auf die Pipette.',
  'Tap a purple feather to take its color.':
    'Tippe auf eine lila Feder, um ihre Farbe zu nehmen.',
  'Now take the Brush.':
    'Nimm jetzt den Pinsel.',
  'Make it bigger: Size 20 or more.':
    'Mach ihn größer: Größe 20 oder mehr.',
  'Paint the white feather purple.':
    'Mal die weiße Feder lila an.',
  'Color the comic':
    'Mal den Comic aus',
  'Fill the shapes with color – one tap each.':
    'Füll die Formen mit Farbe – jede mit einem Tipp.',
  'The Paint bucket fills a whole area at once. Tolerance decides how different the colors in it may be.':
    'Der Farbeimer füllt eine ganze Fläche auf einmal. Die Toleranz bestimmt, wie unterschiedlich die Farben darin sein dürfen.',
  'Tap the Paint bucket.':
    'Tippe auf den Farbeimer.',
  'Tap the orange color.':
    'Tippe auf die orange Farbe.',
  'Tap inside the circle, the square and the triangle.':
    'Tippe in den Kreis, das Quadrat und das Dreieck.',
  'This box is shaded. Slide Tolerance up to 60 or more.':
    'Dieses Rechteck ist schattiert. Schieb die Toleranz auf 60 oder mehr.',
  'Now tap inside the shaded box – all of it fills.':
    'Tippe jetzt in das schattierte Rechteck – es füllt sich ganz.',
  'Fence':
    'Zaun',
  'The garden needs a fence. Draw the posts with straight lines.':
    'Der Garten braucht einen Zaun. Zeichne die Pfosten mit geraden Linien.',
  'The Line tool draws straight lines from where you press to where you let go.':
    'Die Linie zeichnet gerade Linien von da, wo du drückst, bis da, wo du loslässt.',
  'Tap the Line tool.':
    'Tippe auf das Linienwerkzeug.',
  'Tap the dark color.':
    'Tippe auf die dunkle Farbe.',
  'Make the line thicker: Size 8 or more.':
    'Mach die Linie dicker: Größe 8 oder mehr.',
  'Draw a line from each bottom dot up to the dot above it.':
    'Zeichne eine Linie von jedem unteren Punkt hinauf zum Punkt darüber.',
  'Beehive':
    'Bienenstock',
  'Bees build cells with 6 sides. Draw 3 honeycomb cells.':
    'Bienen bauen Zellen mit 6 Seiten. Zeichne 3 Wabenzellen.',
  'The Polygon tool draws shapes with as many sides as you choose – filled, outlined or both.':
    'Das Vieleck zeichnet Formen mit so vielen Seiten, wie du wählst – gefüllt, umrandet oder beides.',
  'Tap the Polygon tool.':
    'Tippe auf das Vieleck-Werkzeug.',
  'Tap 6 – a honeycomb cell has 6 sides.':
    'Tippe auf 6 – eine Wabenzelle hat 6 Seiten.',
  'Turn on Fill – the cells will be full of color.':
    'Schalte Füllen ein – die Zellen werden voller Farbe.',
  'Drag from the middle of each cell outwards.':
    'Zieh von der Mitte jeder Zelle nach außen.',
  'Bubbles':
    'Seifenblasen',
  'Blow 3 round soap bubbles – just the outline, you can see through them.':
    'Puste 3 runde Seifenblasen – nur der Rand, man kann durch sie hindurchsehen.',
  'The Ellipse tool draws circles and ovals. From center starts in the middle; Fill and Outline decide how it looks.':
    'Die Ellipse zeichnet Kreise und Ovale. Von der Mitte beginnt in der Mitte; Füllen und Umriss bestimmen, wie sie aussieht.',
  'Tap the Ellipse tool.':
    'Tippe auf das Ellipsen-Werkzeug.',
  'Choose From center.':
    'Wähl Von der Mitte.',
  'Turn Fill off – a bubble is see-through.':
    'Schalte Füllen aus – eine Seifenblase ist durchsichtig.',
  'Turn Outline on.':
    'Schalte den Umriss ein.',
  'Drag from the middle of each bubble to its edge.':
    'Zieh von der Mitte jeder Seifenblase bis zu ihrem Rand.',
  'Snake':
    'Schlange',
  'Draw a wiggly snake through the dots.':
    'Zeichne eine schlängelnde Schlange durch die Punkte.',
  'The Curve tool draws a smooth line through the points you tap – double-tap (or Enter) finishes it.':
    'Die Kurve zeichnet eine glatte Linie durch die Punkte, die du antippst – Doppeltippen (oder Enter) beendet sie.',
  'Tap the Curve tool.':
    'Tippe auf das Kurven-Werkzeug.',
  'Tap the green color.':
    'Tippe auf die grüne Farbe.',
  'Make it a fat snake: Size 10 or more.':
    'Mach eine dicke Schlange: Größe 10 oder mehr.',
  'Tap the dots one by one from the head to the tail – tap the last one twice to finish.':
    'Tippe die Punkte nacheinander vom Kopf bis zum Schwanz an – den letzten zweimal, dann ist sie fertig.',
  'Move the cat':
    'Trag die Katze',
  'The cat wants to sleep on the red cushion. Carry it there!':
    'Die Katze will auf dem roten Kissen schlafen. Trag sie hin!',
  'Select a part of the picture with a box, drag it somewhere else, then Place it.':
    'Wähl einen Teil des Bildes mit einem Rechteck aus, zieh ihn woandershin und Platziere ihn dann.',
  'Tap the Select tool.':
    'Tippe auf das Auswahl-Werkzeug.',
  'Drag a box around the whole cat.':
    'Zieh ein Rechteck um die ganze Katze.',
  'Now drag the cat onto the cushion.':
    'Zieh die Katze jetzt auf das Kissen.',
  'Tap Place – the cat lies down.':
    'Tippe auf Platzieren – die Katze legt sich hin.',
  'The fish turns round':
    'Der Fisch dreht um',
  'The fish wants to swim the other way – and a little upwards.':
    'Der Fisch will in die andere Richtung schwimmen – und ein bisschen nach oben.',
  'A selection can be flipped, and turned with the round knob above it.':
    'Eine Auswahl kann man spiegeln und mit dem runden Griff darüber drehen.',
  'Drag a box around the fish.':
    'Zieh ein Rechteck um den Fisch.',
  'Tap Flip horizontally – the fish looks the other way.':
    'Tippe auf Horizontal spiegeln – der Fisch schaut in die andere Richtung.',
  'Drag the round knob above the fish a little to the side.':
    'Zieh den runden Griff über dem Fisch ein bisschen zur Seite.',
  'Tap Place.':
    'Tippe auf Platzieren.',
  'Two balloons':
    'Zwei Luftballons',
  'One balloon is not enough. Cut it out along its edge and make a second one.':
    'Ein Luftballon ist nicht genug. Schneide ihn an seinem Rand aus und mach einen zweiten.',
  'The Lasso selects any shape you draw around. Duplicate leaves a copy and gives you a new one to move.':
    'Das Lasso wählt jede Form aus, um die du zeichnest. Duplizieren lässt eine Kopie da und gibt dir eine neue zum Verschieben.',
  'Choose Lasso – it goes around any shape.':
    'Wähl das Lasso – es geht um jede Form herum.',
  'Draw a line all the way around the balloon.':
    'Zeichne eine Linie ganz um den Luftballon herum.',
  'Tap Duplicate.':
    'Tippe auf Duplizieren.',
  'Drag the new balloon over to the empty sky.':
    'Zieh den neuen Luftballon hinüber zum leeren Himmel.',
  'Change the blue sky into an orange sunset.':
    'Verwandle den blauen Himmel in einen orangen Sonnenuntergang.',
  'The Wand selects everything of one color with a single tap. Clear empties the selection.':
    'Der Zauberstab wählt mit einem Tipp alles in einer Farbe aus. Leeren macht die Auswahl leer.',
  'Choose the Wand – it picks one color.':
    'Wähl den Zauberstab – er nimmt eine Farbe.',
  'Tap the blue sky.':
    'Tippe auf den blauen Himmel.',
  'Tap Clear – the sky disappears.':
    'Tippe auf Leeren – der Himmel verschwindet.',
  'Now take the Paint bucket.':
    'Nimm jetzt den Farbeimer.',
  'Tap the empty sky – a sunset!':
    'Tippe auf den leeren Himmel – ein Sonnenuntergang!',
  'Name poster':
    'Namensposter',
  'Write your name on the green banner.':
    'Schreib deinen Namen auf das grüne Band.',
  'The Text tool writes words in any size and font – with an outline, a shadow or bent in a curve.':
    'Das Textwerkzeug schreibt Wörter in jeder Größe und Schrift – mit Umriss, Schatten oder im Bogen.',
  'Tap the Text tool.':
    'Tippe auf das Textwerkzeug.',
  'Tap in the middle of the green banner.':
    'Tippe in die Mitte des grünen Bandes.',
  'Type your name.':
    'Schreib deinen Namen.',
  'Make the letters big: Size 60.':
    'Mach die Buchstaben groß: Größe 60.',
  'Turn on Outline.':
    'Schalte den Umriss ein.',
  'Tap Done.':
    'Tippe auf Fertig.',
  'Drag your name into the banner.':
    'Zieh deinen Namen in das Band.',
  'Twin flowers':
    'Zwillingsblumen',
  'One pot is empty. Grow the same flower in it – copy it with Clone.':
    'Ein Topf ist leer. Lass darin dieselbe Blume wachsen – kopiere sie mit Klonen.',
  'Clone paints with a copy of another part of the picture: first tap where to copy from, then paint.':
    'Klonen malt mit einer Kopie eines anderen Bildteils: Tippe zuerst, woher kopiert wird, dann male.',
  'Tap the Clone tool – the stamp.':
    'Tippe auf Klonen – den Stempel.',
  'Make it big: Size 30 or more.':
    'Mach es groß: Größe 30 oder mehr.',
  'Tap the middle of the flower – the copy comes from there.':
    'Tippe in die Mitte der Blume – von dort kommt die Kopie.',
  'Start in the middle of the dashed circle, then paint all over it – a twin flower grows!':
    'Fang in der Mitte des gestrichelten Kreises an und mal ihn dann ganz aus – eine Zwillingsblume wächst!',
  'Fix the apple':
    'Repariere den Apfel',
  'The apple has 3 scratches. Heal them so it looks new.':
    'Der Apfel hat 3 Kratzer. Repariere sie, damit er wie neu aussieht.',
  'Heal copies a clean part and blends it in, so spots and scratches disappear.':
    'Reparieren kopiert eine saubere Stelle und blendet sie ein, so verschwinden Flecken und Kratzer.',
  'Tap the Heal tool – the plaster.':
    'Tippe auf Reparieren – das Pflaster.',
  'Tap a clean part of the apple.':
    'Tippe auf eine saubere Stelle des Apfels.',
  'Paint over the 3 scratches.':
    'Mal über die 3 Kratzer.',
  'Clean beach':
    'Sauberer Strand',
  'Someone left a can on the beach. Make it disappear!':
    'Jemand hat eine Dose am Strand liegen lassen. Lass sie verschwinden!',
  'Remove fills what you paint over from the picture around it – things vanish.':
    'Entfernen füllt, was du übermalst, mit dem Bild drumherum – Dinge verschwinden.',
  'Tap the Remove tool.':
    'Tippe auf das Entfernen-Werkzeug.',
  'Paint over the whole can, then lift your finger.':
    'Mal über die ganze Dose, dann heb den Finger.',
  'Star sticker':
    'Sternaufkleber',
  'The star looks stuck on. Soften its edge with Blur and give it grain with Noise.':
    'Der Stern sieht aufgeklebt aus. Mach seinen Rand mit Weichzeichnen weich und gib ihm mit Rauschen Körnung.',
  'Blur softens, Noise adds grain – together they blend a pasted picture into a photo.':
    'Weichzeichnen macht weich, Rauschen gibt Körnung – zusammen lassen sie ein eingefügtes Bild mit einem Foto verschmelzen.',
  'Tap the Blur tool – the drop.':
    'Tippe auf Weichzeichnen – den Tropfen.',
  'Make it stronger: slide Strength to 6 or more.':
    'Mach es stärker: Schieb die Stärke auf 6 oder mehr.',
  'Paint along the edge of the star.':
    'Mal am Rand des Sterns entlang.',
  'Now tap the Noise tool – the dots.':
    'Tippe jetzt auf Rauschen – die Punkte.',
  'Slide Amount to 30 or more.':
    'Schieb die Menge auf 30 oder mehr.',
  'Paint over the star – it gets grainy, like the photo.':
    'Mal über den Stern – er wird körnig wie das Foto.',
  'Whirlpool':
    'Strudel',
  'Stir up the lake – make a whirlpool in the circle.':
    'Rühr den See auf – mach einen Strudel im Kreis.',
  'Twist swirls the picture: press the middle, drag out for the size, go round to twist.':
    'Verdrehen wirbelt das Bild: Drück die Mitte, zieh nach außen für die Größe, fahr herum zum Verdrehen.',
  'Tap the Twist tool – the spiral.':
    'Tippe auf Verdrehen – die Spirale.',
  'Press in the middle of the circle, drag out to its edge, then go round and round.':
    'Drück in die Mitte des Kreises, zieh nach außen bis zu seinem Rand, dann fahr rundherum.',
  'Painting':
    'Malen',
  'Selecting and moving':
    'Auswählen und Verschieben',
  'Photo magic':
    'Fotozauber',
  'Lessons':
    'Lektionen',
  'Open the editor':
    'Den Editor öffnen',
  'Learn the tools':
    'Lerne die Werkzeuge',
  'Small tasks, one tool at a time. A glowing frame shows what to tap next – just follow it.':
    'Kleine Aufgaben, ein Werkzeug nach dem anderen. Ein leuchtender Rahmen zeigt, was du als Nächstes antippst – folge ihm einfach.',
  '← All tasks':
    '← Alle Aufgaben',
  '🔊 Read aloud':
    '🔊 Vorlesen',
  '↺ Start again':
    '↺ Noch mal',
  'Well done!':
    'Super gemacht!',
  'All tasks':
    'Alle Aufgaben',
  'Lesson':
    'Lektion',
  'Back to all tasks':
    'Zurück zu allen Aufgaben',
  'Read the instruction aloud':
    'Die Anweisung vorlesen',
  'Start this task again':
    'Diese Aufgabe neu beginnen',
  'Mosaic Paint Raster':
    'Mosaic Paint Raster',
  'Lessons: learn every tool step by step →':
    'Lektionen: Lerne jedes Werkzeug Schritt für Schritt →',
  'Lessons (learn.html, linked from the raster app’s ? guide): 20 small tasks that teach every raster tool, one at a time. A glowing frame shows what to tap next – the tool, its setting, the part of the picture – and the next step comes by itself. The Curve tool now shows the Size slider.':
    'Lektionen (learn.html, verlinkt im ?-Leitfaden der Raster-App): 20 kleine Aufgaben, die jedes Raster-Werkzeug beibringen, eins nach dem anderen. Ein leuchtender Rahmen zeigt, was du als Nächstes antippst – das Werkzeug, seine Einstellung, den Teil des Bildes – und der nächste Schritt kommt von selbst. Das Kurven-Werkzeug zeigt jetzt den Größe-Regler.',
};
